window.slate = window.slate || {};
window.theme = window.theme || {};
/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === "undefined"
        ? ""
        : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === "undefined"
        ? ""
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {
  var selectors = {
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-single-thumbnail]",
    singleOptionSelector: "[data-single-option-selector]",
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = ".product";
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on(
      "variantChange" + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      "variantPriceChange" + this.namespace,
      this.updateProductPrices.bind(this)
    );

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(
        this.$featuredImage.attr("src")
      );
      slate.Image.preload(
        this.productSingleObject.images,
        this.settings.imageSize
      );

      this.$container.on(
        "variantImageChange" + this.namespace,
        this.updateProductImage.bind(this)
      );
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass("hide");
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass("hide");
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop("disabled", false);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass("hide");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      this.$featuredImage.attr("src", sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $("#AddressNewForm");

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      {
        hideElement: "AddressProvinceContainerNew",
      }
    );
  }

  // Initialize each edit form's country/province selector
  $(".address-country-option").each(function () {
    var formId = $(this).data("form-id");
    var countrySelector = "AddressCountry_" + formId;
    var provinceSelector = "AddressProvince_" + formId;
    var containerSelector = "AddressProvinceContainer_" + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $(".address-new-toggle").on("click", function () {
    $newAddressForm.toggleClass("hide");
  });

  $(".address-edit-toggle").on("click", function () {
    var formId = $(this).data("form-id");
    $("#EditAddress_" + formId).toggleClass("hide");
  });

  $(".address-delete").on("click", function () {
    var $el = $(this);
    var formId = $el.data("form-id");
    var confirmMessage = $el.data("confirm-message");
    if (
      confirm(confirmMessage || "Are you sure you wish to delete this address?")
    ) {
      Shopify.postLink("/account/addresses/" + formId, {
        parameters: { _method: "delete" },
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: "#RecoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }
})();

/*================ Theme ================*/
("use strict");

var home = {
  //state
  logoAnimation: null,

  init: function init() {
    if (
      window.location.pathname === "/" ||
      window.location.pathname.startsWith("/cart") ||
      window.location.pathname === "/account/register" ||
      window.location.pathname === "/account/login" ||
      window.location.pathname.startsWith("/account/reset/")
    ) {
      home.setListeners();
      home.initSwiper();
      home.initLogoAnimation();
      collection.registerClickEvents();
    }

    if (window.location.pathname === "/pages/black-friday") {
      collection.registerClickEvents();
    }
  },
  setListeners: function setListeners() {
    if (site.isDesktop) {
      // home.onHeroBtnHover();
      home.onPromoBtnHover();
      home.onWhiteQuadBtnHover();
      home.onBrownQuadBtnHover();
      home.onPurpleQuadBtnHover();
    }
  },
  hoverConstructor: function hoverConstructor(selector, mouseIn, mouseOut) {
    $(selector).mouseenter(mouseIn).mouseleave(mouseOut);
  },
  //  This constructor triggers the logo badge in the hero section.
  //
  // heroIn: () => {
  //   $(".hero__mask").css("opacity", "1");
  // },
  // heroOut: () => {
  //   $(".hero__mask").css("opacity", "0");
  // },
  // onHeroBtnHover: () => {
  //   home.hoverConstructor(".btn__hero", home.heroIn, home.heroOut);
  // },
  promoIn: function promoIn() {
    $(".home__promo__root").addClass("triggered");
  },
  promoOut: function promoOut() {
    $(".home__promo__root").removeClass("triggered");
  },
  onPromoBtnHover: function onPromoBtnHover() {
    home.hoverConstructor(".btn__promo", home.promoIn, home.promoOut);
  },
  whiteQuadIn: function whiteQuadIn() {
    $(".quad__white__root").addClass("triggered");
  },
  whiteQuadOut: function whiteQuadOut() {
    $(".quad__white__root").removeClass("triggered");
  },
  onWhiteQuadBtnHover: function onWhiteQuadBtnHover() {
    home.hoverConstructor(
      ".btn__white__quad",
      home.whiteQuadIn,
      home.whiteQuadOut
    );
  },
  brownQuadIn: function brownQuadIn() {
    $(".quad__brown__root").addClass("triggered");
  },
  brownQuadOut: function brownQuadOut() {
    $(".quad__brown__root").removeClass("triggered");
  },
  onBrownQuadBtnHover: function onBrownQuadBtnHover() {
    home.hoverConstructor(
      ".btn__brown__quad",
      home.brownQuadIn,
      home.brownQuadOut
    );
  },
  purpleQuadIn: function purpleQuadIn() {
    home.logoAnimation.play();
  },
  purpleQuadOut: function purpleQuadOut() {
    home.logoAnimation.stop();
  },
  onPurpleQuadBtnHover: function onPurpleQuadBtnHover() {
    home.hoverConstructor(
      ".btn__purple__quad",
      home.purpleQuadIn,
      home.purpleQuadOut
    );
  },
  initLogoAnimation: function initLogoAnimation() {
    home.logoAnimation = bodymovin.loadAnimation({
      container: document.getElementById("logo__animation"),
      renderer: "svg",
      loop: true,
      autoplay: false,
      path: "https://cdn.shopify.com/s/files/1/0027/8134/7953/files/home_logo_white.json?10255663254723096920",
    });
  },
  initSwiper: function initSwiper() {
    $(".slider__home__best").flickity({
      // options
      cellAlign: "center",
      contain: false,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      initialIndex: 0,
      on: {
        change: function change(index) {
          var slide = parseInt(index + 1);
          $(".home__slide__count").text(slide);
        },
      },
    });
  },
};

("use strict");

var product = {
  //state
  carousel: null,
  activeColor: null,
  activeOption2: null,
  activeOption3: null,
  activeVariant: null,

  init: function init() {
    if (window.location.href.indexOf("/product") != -1) {
      product.setClickEvents();
      product.initSlider();
      product.readInitialOptionValues();
      product.set3dImage();
      product.setMatchingImage();
      product.scrollMonitor();
      product.checkType();
      product.checkParams();
    }
  },
  setClickEvents: function setClickEvents() {
    product.onDesktopThumbnailClick();
    product.onSwatchClick();
    product.onMainImageClick();
    product.onSizeGuideClick();
    product.onOptionClick();
    product.onNotifyMeClick();
    product.onInfoTopClick();
    product.onAddToCartClick();
    product.onMatchingProductCancel();
  },
  checkType: function checkType() {
    var isBra = $(".product__top__root").data("bra");
    if (isBra) {
      $(".link-Bras").addClass("active");
    } else {
      $(".link-Underwear").addClass("active");
    }
  },
  checkParams: function checkParams() {
    if (site.getUrlParams("color") !== null) {
      var color = site.getUrlParams("color");
      $('.swatch[data-color="' + color + '"]').trigger("click");
    }
  },
  scrollMonitor: (function (_scrollMonitor) {
    function scrollMonitor() {
      return _scrollMonitor.apply(this, arguments);
    }

    scrollMonitor.toString = function () {
      return _scrollMonitor.toString();
    };

    return scrollMonitor;
  })(function () {
    var el = document.querySelectorAll(".monitor__trigger");
    var cta = document.getElementById("to__top");
    var elWatcher = scrollMonitor.create(el);

    elWatcher.enterViewport(function () {
      cta.style.opacity = "1";
    });
    elWatcher.exitViewport(function () {
      cta.style.opacity = "0";
    });
  }),
  initSlider: function initSlider() {
    product.carousel = new Flickity(".product__slider", {
      // options
      cellAlign: "center",
      contain: false,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      initialIndex: 0,
      on: {
        ready: function ready(index) {
          $(".count > .current").text("1");
          $(".count > .total").text($(".flickity-slider").children().length);
        },
        change: function change(index) {
          var slide = parseInt(index + 1);
          $(".count > .current").text(slide);
          $(".count > .total").text($(".flickity-slider").children().length);
        },
      },
    });
  },
  readInitialOptionValues: function readInitialOptionValues() {
    var color = $('div[data-for-option="Color"] > .active > .swatch').data(
      "value"
    );

    // Set state
    product.activeColor = color;
  },
  setActiveColor: function setActiveColor() {
    product.activeColor = $(
      'div[data-for-option="Color"] > .active > .swatch'
    ).data("value");
    // Deselect sizes
    $(".size").removeClass("selected");
  },
  set3dImage: function set3dImage() {
    var color = product.activeColor.toLowerCase().replace(/ /g, "-");
    var src1 = $(
      '.variant__3d[data-role="1"][data-color="' + color + '"]'
    ).data("src");
    var src2 = $(
      '.variant__3d[data-role="2"][data-color="' + color + '"]'
    ).data("src");
    $(".product__3d__target").css("background", "url('" + src2 + "')");
  },
  setMatchingImage: function setMatchingImage() {
    var color = product.activeColor.toLowerCase();
    var handle = $(".matching__img__ref").data("handle");
    var href = "/products/" + handle + "?matching=1&color=" + color;
    var src = $('.matching__img[data-color="' + color + '"]').data("src");
    $(".matching__img__target").attr("src", src);
    $(".matching__link").attr("href", href);
  },
  onDesktopThumbnailClick: function onDesktopThumbnailClick() {
    $(".product__top__root > .controls > .preview").on(
      "click",
      function (event) {
        // Set the active state
        $(this).parent().children().removeClass("active");

        $(this).addClass("active");

        // Grab the index and display the main
        var index = $(this).data("index");
        $(".main > img").addClass("display__none");
        $('.main > img[data-index="' + index + '"]').removeClass(
          "display__none"
        );

        // Update lazy load
        lazy.controller.update();
      }
    );
  },
  onSwatchClick: function onSwatchClick() {
    $(".swatch").on("click", function (event) {
      if ($(this).hasClass("active")) {
        return;
      }
      // Show/hide thumbnails
      var color = $(this).data("color");
      $(".controls > .preview").addClass("display__none").removeClass("active");
      $(".preview[data-color='" + color + "']").removeClass("display__none");
      $(".preview[data-role='1'][data-color='" + color + "']").addClass(
        "active"
      );
      console.log('tessst  = ' + color);
      // Show/hide main & slide images
      $(".main > img").addClass("display__none");
      $('.main > img[data-role="1"][data-color="' + color + '"]').removeClass(
        "display__none"
      );

      // Show/hide main modal images
      $(".modal__image").addClass("display__none");
      $('.modal__image[data-color="' + color + '"]').removeClass(
        "display__none"
      );

      // Update lazy load
      lazy.controller.update();

      // Update slider
      product.updateSlideImagesTo(color);

      // Update span text
      var textVal = $(this).data("value");
      $("span.append").text(textVal);

      // Active swatch state
      $(".swatch__container").children().removeClass("active");
      $(this).parent().addClass("active");

      // Update state
      product.setActiveColor();
      product.setNeutralButtonState();
      product.set3dImage();
      product.activeOption2 = null;
      product.activeOption3 = null;
      product.setMatchingImage();
    });
  },
  onMainImageClick: function onMainImageClick() {
    $(document).on("click", ".product__top__root > .main > img", function () {
      $(".product__main__modal__root").removeClass("display__none");
      site.lockBodyScroll();
    });
    $(document).on("click", ".product__magnify", function () {
      $(".product__main__modal__root").removeClass("display__none");
      site.lockBodyScroll();
    });
  },
  onSizeGuideClick: function onSizeGuideClick() {
    $(".options > .guide").on("click", function () {
      $(".product__size__modal__root").removeClass("display__none");
      site.lockBodyScroll();
    });
  },
  onOptionClick: function onOptionClick() {
    $(".options__container > .size").on("click", function (event) {
      $(this).parent().children().removeClass("selected");
      $(this).addClass("selected");

      var value = $(this).data("value");

      // Check if only option
      var isOnlyOption = $(this).hasClass("only__option");
      if (isOnlyOption) {
        product.activeOption2 = value;
        product.runSimpleStockCheck(value);
      } else {
        // Else start building your complex query
        var valIndex = $(this).parent().data("option-index");
        if (valIndex === 2) {
          product.activeOption2 = value;
        }
        if (valIndex === 3) {
          product.activeOption3 = value;
        }
        product.runComplexStockCheck();
      }
    });
  },
  runSimpleStockCheck: function runSimpleStockCheck(size) {
    var activeColor = product.activeColor;

    var isAvailable = $(
      ".product__variant__reference[data-option1='" +
        activeColor +
        "'][data-option2='" +
        size +
        "']"
    ).data("available");

    var variantId = $(
      ".product__variant__reference[data-option1='" +
        activeColor +
        "'][data-option2='" +
        size +
        "']"
    ).data("variant-id");
    if (variantId === undefined) {
      product.doesntExist();
    } else {
      if (isAvailable) {
        product.activeVariant = variantId;
        product.allowPurchase();
      } else {
        product.activeVariant = null;
        product.disallowPurchase();
        // Give the notify button a data attr
        $("#notifySubmit").attr("data-id", variantId);
      }
    }
  },
  runComplexStockCheck: function runComplexStockCheck() {
    var activeColor = product.activeColor,
      activeOption2 = product.activeOption2,
      activeOption3 = product.activeOption3;

    if (activeOption2 !== null && activeOption3 !== null) {
      var isAvailable = $(
        ".product__variant__reference[data-option1='" +
          activeColor +
          "'][data-option2='" +
          activeOption2 +
          "'][data-option3='" +
          activeOption3 +
          "']"
      ).data("available");

      var variantId = $(
        ".product__variant__reference[data-option1='" +
          activeColor +
          "'][data-option2='" +
          activeOption2 +
          "'][data-option3='" +
          activeOption3 +
          "']"
      ).data("variant-id");
      if (variantId === undefined) {
        product.doesntExist();
      } else {
        if (isAvailable) {
          product.activeVariant = variantId;
          product.allowPurchase();
        } else {
          product.activeVariant = null;
          product.disallowPurchase();
          // Give the notify button a data attr
          $("#notifySubmit").attr("data-id", variantId);
        }
      }
    }
  },
  onNotifyMeClick: function onNotifyMeClick() {
    $(document).on("click", ".notify", function () {
      // Get the size & color vars for modal
      var swatch =
        "swatch__" + $(".swatch__container > .active > .swatch").data("color");
      $(".block__color > .bubble > .swatch").addClass(swatch);
      $(".notify__modal__color").text(product.activeColor);
      $(".block__size1 > .size").text(
        helpers.formatLongBubble(product.activeOption2)
      );
      $(".block__size2 > .size").text(product.activeOption3);

      // Open modal
      $(".product__notify__modal__root").removeClass("display__none");
      site.lockBodyScroll();
    });
  },
  allowPurchase: function allowPurchase() {
    $(".product__add__btn")
      .removeClass("disabled")
      .removeClass("notify")
      .addClass("product__ready")
      .text("Add To Bag");
  },
  disallowPurchase: function disallowPurchase() {
    $(".product__add__btn")
      .removeClass("disabled")
      .removeClass("product__ready")
      .addClass("notify")
      .text("Out of Stock - Notify Me");
  },
  doesntExist: function doesntExist() {
    $(".product__add__btn")
      .addClass("disabled")
      .removeClass("product__ready")
      .removeClass("notify")
      .text("Size Unavailable");
  },
  setNeutralButtonState: function setNeutralButtonState() {
    $(".product__add__btn")
      .addClass("disabled")
      .removeClass("product__ready")
      .removeClass("notify")
      .text("Add To Bag");
  },
  onAddToCartClick: function onAddToCartClick() {
    $(document).on("click", ".product__ready", function () {
      var id = product.activeVariant;
      var qty = 1;
      var title = $(".product__title__1").text();
      product.startLoadingState();
      cart.startLoadingState();
      cart.setAnimationText(title, $(".product__top__root").data("id"));
      cart.addItem(id, qty, true);
    });
  },
  updateSlideImagesTo: function updateSlideImagesTo(color) {
    // Remove Slides
    $(".flickity-slider").empty();

    // Gather new images
    var ref = $('.main > img[data-color="' + color + '"]');
    var index = 0;
    var elements = "";
    $(ref).each(function () {
      var src = $(this).data("src");
      var is3d = src.includes("-3dview");
      index++;
      if (!is3d) {
        var slide =
          '<div class="carousel-cell"><img src="' +
          src +
          '" alt="' +
          color +
          " image " +
          index +
          '"></div>';
        elements = elements + slide;
      }
    });
    // Append
    $(".flickity-slider").append(elements);
    // Re-init carousel
    product.carousel.reloadCells();

    // Force an interaction to ensure all the cells load
    product.carousel.select(0);
  },
  onInfoTopClick: function onInfoTopClick() {
    $("#to__top").on("click", function () {
      $("html, body").scrollTo(".product__top__root", 500);
    });
  },
  onMatchingProductCancel: function onMatchingProductCancel() {
    $(".product__matching__close").on("click", function () {
      $(".product__matching__root").remove();
    });
  },
  startLoadingState: function startLoadingState() {
    $(".product__top__root > .details").addClass("loading");
  },
  finishLoadingState: function finishLoadingState() {
    $(".product__top__root > .details").removeClass("loading");
  },
};

("use strict");

var collection = {
  //state
  allCurrentProducts: [],
  allCurrentIds: [],
  activeProductId: "",
  activeVariantId: "",
  activeProductColor: "",
  uniqueColors: [],
  rootClone: "",
  hasCheckedParams: false,
  mobileFilters: {
    style: null,
    color: null,
    band: null,
    cup: null,
    size: null,
    count: 0,
  },

  init: function init() {
    if (window.location.pathname.startsWith("/coll")) {
      // Init functions
      collection.getHeroImage();
      collection.registerClickEvents();
      collection.scrollMonitor();
      collection.getCollectionProducts();
    }

    if (window.location.pathname.startsWith("/prod")) {
      collection.registerSharedClickEvents();
    }

    if (window.location.pathname.includes("-bra-")) {
      collection.getHeroImage();
    }
  },
  checkParams: function checkParams() {
    var pathname = window.location.pathname;
    var braCollectionPage = pathname.includes("-bras");
    var hasParams =
      site.getUrlParams("bandSize") != null ||
      site.getUrlParams("cupSize") != null;
    var cupSize;
    var bandSize;
    if (braCollectionPage) {
      braCollectionPage = true;
      var end = pathname.split("/")[2];
      var a = end.split("-")[0];
      bandSize = a.slice(0, 2);
      cupSize = a.slice(2).toUpperCase();
    }
    if (hasParams) {
      cupSize = site.getUrlParams("cupSize");
      bandSize = site.getUrlParams("bandSize");
    }
    if (braCollectionPage || hasParams) {
      var ref = $(
        '.desktop__filter__option[data-band-size="' +
          bandSize +
          '"][data-cup-size="' +
          cupSize +
          '"]'
      );
      var mRef = $(
        '.mobile__filter__option[data-band-size="' +
          bandSize +
          '"][data-cup-size="' +
          cupSize +
          '"]'
      );
      if (ref.length) {
        if (site.isMobile) {
          $(mRef).trigger("click");
          $(".filter__modal__apply").trigger("click");
        } else {
          $(ref).trigger("click");
        }
      } else {
        $(".product__root").remove();
        collection.checkForEmptyResults();
        $(".product__filters__remove").removeClass("display__none");
        $("html, body").scrollTo(".scrollTarget", 500);
      }
      collection.hasCheckedParams = true;
    }
  },
  registerClickEvents: function registerClickEvents() {
    collection.onDesktopQuickAdd();
    collection.onMobileQuickAdd();
    collection.onSwatchSelect();
    collection.onOptionSelect();
    collection.onDesktopFilterClick();
    collection.onDesktopClearFilters();
    collection.onDeselectFilterTag();
    collection.onMobileFilterLabelClick();
    collection.onMobileFilterMenuClick();
    collection.onMobileFilterModalOptionClick();
    collection.onMobileFilterModalClearAll();
    collection.onMobileFilterModalApply();
    collection.onAddToCartClick();
    collection.onClickAllSizes();
  },
  registerSharedClickEvents: function registerSharedClickEvents() {
    collection.onDesktopQuickAdd();
    collection.onMobileQuickAdd();
    collection.onSwatchSelect();
    collection.onOptionSelect();
    collection.onAddToCartClick();
  },
  onClickAllSizes: function onClickAllSizes() {
    $(".collection__sizes__btn").on("click", function () {
      $(".collection__sizes").removeClass("hidden");
      $("html, body").scrollTo($(".collection__sizes"), 1000, { offset: -80 });
    });
  },
  scrollMonitor: function scrollMonitor() {
    $(window).scroll(function (event) {
      var scrollPosition = $(window).scrollTop();
      var scrollTarget = site.isMobile ? 275 : 385;
      if (scrollPosition > scrollTarget) {
        $(
          ".collection__filter__root, .collection__listing__root, .hover__list"
        ).addClass("filter__fixed");
      } else {
        $(
          ".collection__filter__root, .collection__listing__root, .hover__list"
        ).removeClass("filter__fixed");
      }
    });
  },
  getHeroImage: function getHeroImage() {
    var el = document.getElementById("collection__hero");
    if (el) {
      if (site.isMobile) {
        el.style.backgroundImage = el.dataset.mimg;
      } else {
        el.style.backgroundImage = el.dataset.dimg;
      }
    }
  },
  getCollectionProducts: function getCollectionProducts() {
    var currentPath = window.location.pathname;
    var queryUrl = currentPath + "/products.json";
    $.get(queryUrl, function (data) {
      // Add the collection to local state for filtering
      collection.allCurrentProducts = data.products;
      collection.allCurrentIds = _.pluck(data.products, "id");
    }).done(function () {
      collection.getCollectionColors();
      if (!collection.hasCheckedParams) {
        collection.checkParams();
      }
    });

    // Clone the initial view for use in filters
    collection.rootClone = $(".full__clone__root").clone();
  },
  getCollectionColors: function getCollectionColors() {
    // Get the raw values from the color swatches on the page
    var ref = $(".product__swatch");
    var rawColors = [];
    $(ref).each(function () {
      var val = $(this).data("value");
      rawColors.push(val);
    });
    // Filter out duplicates
    collection.uniqueColors = _.uniq(rawColors);
    // Append them to the color filter list
    _.map(collection.uniqueColors, function (color) {
      //Change case of string, replace hyphens with spaces and capitalize first letter
      function prettify(str) {
        return str.replace(/(-|^)([^-]?)/g, function (_, prep, letter) {
          return (prep && " ") + letter.toUpperCase();
        });
      }
      color = prettify(color);
      $('div[data-label="color"] > ul').append(
        "<li class='desktop__filter__option' data-filter-type='color' data-value='" +
          color +
          "'><span>" +
          color +
          "</span></li>"
      );
      $('div[data-wrapper-for="color"] > ul').append(
        "<li class='mobile__filter__option' data-filter-type='color' data-value='" +
          color +
          "'><span>" +
          color +
          "</span></li>"
      );
    });
  },
  onDesktopQuickAdd: function onDesktopQuickAdd() {
    $(document).on("click", ".product__quick__btn > .btn", function (event) {
      var productId = $(this).data("for-product");
      var prodHandle = $(this).data("for-handle");
      collection.openDesktopQuickAddWindow(productId, prodHandle);
    });

    // Cancel window
    $(document).on("click", ".quick__cancel", function (event) {
      var windowId = $(this).data("for-window");
      $("div[data-product-id = " + windowId + "]").removeClass(
        "quick-add-enabled"
      );
    });
  },
  openDesktopQuickAddWindow: function openDesktopQuickAddWindow(
    productId,
    prodHandle
  ) {
    // Disable other quick add windows & settings from previous window activity
    $("div").removeClass("quick-add-enabled able-to-add");

    // Then enable this one
    $("div[data-product-id = " + productId + "]").addClass("quick-add-enabled");

    // Disable quick-add btn & set initial btn text
    $(".quick__add__to__cart")
      .addClass("disabled")
      .removeClass("collection__product__ready");
    $(".quick__add__to__cart > .btn").text("Add to Bag");

    // Set the current active product ID for use in other methods
    collection.activeProductId = productId;

    // Get & set the current product color selected for use in other methods
    var currentColor = $(
      "div[data-product-id = " +
        productId +
        "] > .product__details > .collection__product__colors > .selected"
    ).data("value");

    collection.activeProductColor = currentColor;

    // Turn on loading icon
    collection.enableWindowLoadingIcon();

    // Run product query
    collection.runProductQuery(prodHandle, productId);
  },
  onMobileQuickAdd: function onMobileQuickAdd() {
    $(document).on("click", ".product__mobile__quick__btn", function (event) {
      if (site.isMobile) {
        // Get your product ID & clone it's quick-add container
        var id = $(this).data("modal-for");
        var optClone = $(".inner[data-inner-for=" + id + "]").clone();
        // Clear out the quick modal and append the clone
        $(
          ".collection__quick__add__modal__root > .container > .row > .modal__content"
        )
          .empty()
          .append(optClone[0]);
        collection.openQuickModal();

        // Turn on loading icon
        collection.enableWindowLoadingIcon();

        // Set the current active product ID for use in other methods
        collection.activeProductId = id;

        // Get & set the current product color selected for use in other methods
        var currentColor = $(
          "div[data-product-id = " +
            id +
            "] > .product__details > .collection__product__colors > .selected"
        ).data("value");
        collection.activeProductColor = currentColor;

        // Grab the product data
        var prodHandle = $(this).data("for-handle");

        // Run the query
        collection.runProductQuery(prodHandle, id);
      } else {
        var productId = $(this).data("modal-for");
        var prodHandle = $(this).data("for-handle");
        collection.openDesktopQuickAddWindow(productId, prodHandle);
      }
    });
  },
  runProductQuery: function runProductQuery(handle, id) {
    var queryUrl = "/products/" + handle + ".json";

    $.get(queryUrl, function (data) {
      // Render the first size options
      $(
        "div[data-options-for = " + id + "] > .opt__wrapper > .size__2"
      ).empty();
      _.map(data.product.options[1].values, function (option) {
        $(
          "div[data-options-for = " + id + "] > .opt__wrapper > .size__2"
        ).append(
          "<div class='collection__option__bubble only__option' data-value='" +
            option +
            "'><span>" +
            helpers.formatLongBubble(option) +
            "</span></div>"
        );
      });

      // If theres another size option, render them also
      if (data.product.options[2]) {
        // Let the DOM know that there are two options left on the board
        $("div").removeClass("only__option");
        // Append the second options
        $(
          "div[data-options-for = " + id + "] > .opt__wrapper > .size__3"
        ).empty();
        _.map(data.product.options[2].values, function (option) {
          $(
            "div[data-options-for = " + id + "] > .opt__wrapper > .size__3"
          ).append(
            "<div class='collection__option__bubble' data-value='" +
              option +
              "'><span>" +
              option +
              "</span></div>"
          );
        });
      }

      // Disable loading icon
      collection.disableWindowLoadingIcon();
    });
  },
  onOptionSelect: function onOptionSelect() {
    $(document).on("click", ".collection__option__bubble", function (event) {
      // Check if only option
      var onlyOption = $(this).hasClass("only__option");
      //Change case of string, replace hyphens with spaces and capitalize first letter
      function prettify(str) {
        return str.replace(/(-|^)([^-]?)/g, function (_, prep, letter) {
          return (prep && " ") + letter.toUpperCase();
        });
      }
      // Set the global attributes for the query
      var color = collection.activeProductColor;
      var id = collection.activeProductId;
      var size = $(this).data("value");
      color = prettify(color);
      //console.log(color, id, size);
      // Deselect other bubbles in this option category & enable this one
      $(this).parent().children().removeClass("option__selected");
      $(this).addClass("option__selected");

      if (onlyOption) {
        // Find & check the variant availability in the reference table
        var ref = $(
          ".variant__table-" +
            id +
            " > div[data-option1='" +
            color +
            "'][data-option2='" +
            size +
            "']"
        );
        if (ref.data("available")) {
          $(".quick__add__to__cart")
            .removeClass("disabled")
            .addClass("collection__product__ready");
          $(".quick__add__to__cart > .btn").text("Add to Bag");
          collection.activeVariantId = ref.data("variant-id");
        } else {
          $(".quick__add__to__cart")
            .addClass("disabled")
            .removeClass("collection__product__ready");
          $(".quick__add__to__cart > .btn").text("Out of Stock");
        }
      } else {
        // Set the relationship between the two sets of options
        var targetIndex;
        var ref;
        var isSize2 = $(this).parent().hasClass("size__2");
        targetIndex = isSize2 ? "2" : "3";
        filterContainer = isSize2 ? ".size__3" : ".size__2";
        filterIndex = isSize2 ? "3" : "2";
        ref =
          ".variant__table-" +
          id +
          " > div[data-option1='" +
          color +
          "'][data-option" +
          targetIndex +
          "='" +
          size +
          "']";
        // Start filter process by defaulting all options to be filtered to disabled
        $(filterContainer)
          .children()
          .addClass("disabled")
          .removeClass("able-to-add");
        //console.log(id, color, targetIndex, size, ref, filterContainer, filterIndex);
        //console.log(ref);
        $(ref).each(function () {
          // For each of the results from the ref table,
          // 1. map over the options and grab their values
          // 2. in the filter options div, enable each option if it's available
          var available = $(this).data("available");
          var val = $(this).data("option" + filterIndex);
          //console.log(available, val);
          if (available) {
            // console.log(available, val);
            $('div[data-value="' + val + '"]')
              .removeClass("disabled")
              .addClass("able-to-add");
          } else {
            //console.log(available, val);
            $('div[data-value="' + val + '"]')
              .removeClass("able-to-add")
              .addClass("disabled");
          }
        });
        // If the user has reached a viable combination, enable add-to-cart & find the variant ID
        if ($(this).hasClass("able-to-add")) {
          var opt1 = collection.activeProductColor;
          var opt2 = $(
            'div[data-options-for="' +
              id +
              '"] > .opt__wrapper > .size__2 > .option__selected'
          ).data("value");
          var opt3 = $(
            'div[data-options-for="' +
              id +
              '"] > .opt__wrapper > .size__3 > .option__selected'
          ).data("value");
          //console.log(id, opt1, opt2, opt3);
          //Needed to captialize first letter of color eg. 'black' to 'Black'
          opt1 = prettify(opt1);
          // Set variant ID for add to cart action
          collection.activeVariantId = $(
            'div[data-variant-of="' +
              id +
              '"][data-option1="' +
              opt1 +
              '"][data-option2="' +
              opt2 +
              '"][data-option3="' +
              opt3 +
              '"]'
          ).data("variant-id");
          //console.log(collection.activeVariantId, opt1);
          $(".quick__add__to__cart")
            .removeClass("disabled")
            .addClass("collection__product__ready");
        } else {
          // It shouldn't be possible to achieve this, but just in case - add null check on the ATC btn
          $(".quick__add__to__cart")
            .addClass("disabled")
            .removeClass("collection__product__ready");
        }
      }
    });
  },
  onMobileFilterLabelClick: function onMobileFilterLabelClick() {
    $(".filter__mobile__tablet > .row > .label").on("click", function () {
      collection.openFilterModal();
    });
    $(".filter__modal__cancel").on("click", function () {
      collection.closeFilterModal();
    });
  },
  onMobileFilterMenuClick: function onMobileFilterMenuClick() {
    $(".mobile__filter__menu__item").on("click", function (event) {
      $(this).parent().children().removeClass("active");
      $(this).addClass("active");
      // Enable the related menu page
      var page = $(this).data("for");
      $(".options > .wrapper").addClass("display__none");
      $('div[data-wrapper-for="' + page + '"]').removeClass("display__none");
    });
  },
  onMobileFilterModalOptionClick: function onMobileFilterModalOptionClick() {
    $(document).on("click", ".mobile__filter__option", function (event) {
      // Get the filter type
      var type = $(this).data("filter-type");
      // Check if deselecting
      var isDeselecting = $(this).hasClass("selected");
      if (isDeselecting) {
        $(this).removeClass("selected");
        // Clear the relevant filter
        if (type === "bra-size") {
          collection.mobileFilters.band = null;
          collection.mobileFilters.cup = null;
          // (1)
          $('.mobile__filter__menu__item[data-for="size"]').removeClass(
            "hasSelection"
          );
        } else {
          collection.mobileFilters[type] = null;
          // (1)
          $('.mobile__filter__menu__item[data-for="' + type + '"]').removeClass(
            "hasSelection"
          );
        }

        // Update the filter count
        collection.mobileFilters.count = collection.mobileFilters.count - 1;
        // Reset
        if (collection.mobileFilters.count === 0) {
          // Reset products
          collection.resetCollection();

          // Reset count
          $(".filter__count").empty();

          // Rm count
          $(".mobile__filter__menu__item").removeClass("hasSelection");

          // Disable apply
          $(".filter__modal__apply").addClass("disabled");
        }
      } else {
        // Check if this is the first time they've selected this type of filter
        var previous = $(this).parent().find(".selected");

        // Set the selected option
        $(this).parent().children().removeClass("selected");
        $(this).addClass("selected");
        $(".filter__modal__apply").removeClass("disabled");

        // Give the header the (1)

        var cup = void 0;
        var band = void 0;
        if (type === "bra-size") {
          // (1)
          $('.mobile__filter__menu__item[data-for="size"]').addClass(
            "hasSelection"
          );

          // Grab the two separate values
          band = $(this).data("band-size");
          cup = $(this).data("cup-size");
          // Add them to the local state
          $(".filter__modal__apply");
          collection.mobileFilters.cup = cup;
          collection.mobileFilters.band = band;
        } else {
          // (1)
          $('.mobile__filter__menu__item[data-for="' + type + '"]').addClass(
            "hasSelection"
          );

          var val = $(this).data("value");
          if (type === "style") {
            collection.mobileFilters.style = val;
          }
          if (type === "size") {
            collection.mobileFilters.size = val;
          }
          if (type === "color") {
            collection.mobileFilters.color = val;
          }
        }
        // Update the filter count
        if (previous.length === 0 && collection.mobileFilters.count !== 3) {
          collection.mobileFilters.count = collection.mobileFilters.count + 1;
        }
      }
    });
  },
  onMobileFilterModalClearAll: function onMobileFilterModalClearAll() {
    $(".filter__modal__clear").on("click", function () {
      $(".mobile__filter__option").removeClass("selected");
      // Reset values
      collection.mobileFilters.style = null;
      collection.mobileFilters.color = null;
      collection.mobileFilters.size = null;
      collection.mobileFilters.cup = null;
      collection.mobileFilters.band = null;
      collection.mobileFilters.count = 0;

      // Reset products
      collection.resetCollection();

      // Reset count
      $(".filter__count").empty();

      // Rm count
      $(".mobile__filter__menu__item").removeClass("hasSelection");

      // Disable apply
      $(".filter__modal__apply").addClass("disabled");
    });
  },
  onMobileFilterModalApply: function onMobileFilterModalApply() {
    $(".filter__modal__apply").on("click", function (event) {
      // Fresh reset
      collection.resetCollection();

      // Get the new data attrs
      var size = collection.mobileFilters.size;
      var cup = collection.mobileFilters.cup;
      var band = collection.mobileFilters.band;
      var color = collection.mobileFilters.color;
      var style = collection.mobileFilters.style;
      var count = collection.mobileFilters.count;

      // Conditionally run each filter
      if (size && size !== null) {
        collection.runSimpleFilter("size", size, null);
      }
      if (color && color !== null) {
        collection.runSimpleFilter("color", color, null);
      }
      if (style && style !== null) {
        collection.runSimpleFilter("style", style, null);
      }
      if (cup && band && cup !== null && band !== null) {
        collection.runBraSizeFilter("bra-size", band, cup, null);
      }

      // Set the count
      $(".filter__count").text("(" + count + ")");

      // Close modal
      collection.closeFilterModal();

      // Check if no results
      collection.checkForEmptyResults();

      // Scroll return
      $("html, body").scrollTo(".scrollTarget", 500);
    });
  },
  onDesktopFilterClick: function onDesktopFilterClick() {
    $(document).on("click", ".desktop__filter__option", function (event) {
      // Check if any others are enabled
      var type = $(this).data("filter-type");
      var otherOfType = $('.is__clone[data-type="' + type + '"]');

      if (otherOfType.length > 0) {
        // Remove it from the DOM with its click function
        otherOfType.trigger("click");
        // Remove selected UI from others of this type
        $(this).parent().children().removeClass("selected");
      }

      // Add selected style
      $(this).addClass("selected");
      // Enable remove all btn
      $(".product__filters__remove").removeClass("display__none");
      // Clone the first filter bubble
      var clone = $(".filter__bubble__clone").clone();
      // Remove the clone selector
      clone
        .removeClass("filter__bubble__clone display__none")
        .addClass("is__clone");
      // Add your own values from the click event
      clone.find("span").text($(this).text());
      // Append it to the parent
      $(".product__filters__applied")
        .append(clone)
        // If the things exceed the parent container, scroll max left
        .scrollLeft(10000);

      // Start the filter query by getting the attributes from the clicked option
      if (type === "bra-size") {
        var band = $(this).data("band-size");
        var cup = $(this).data("cup-size");
        // Pass clone for callback so it can be appended a reference data value noting which products it's responsible for removing from DOM
        collection.runBraSizeFilter(type, band, cup, clone);
      } else {
        var value = $(this).data("value");
        collection.runSimpleFilter(type, value, clone);
      }

      // Check if no results
      collection.checkForEmptyResults();
      // Scroll reset
      collection.resetScroll();
    });
  },
  runSimpleFilter: function runSimpleFilter(type, value, newTag) {
    var removedProductIds = [];

    $(".product__root").each(function () {
      // Grab the top level color values
      var values = $(this).data(type + "-values");
      // Turn it into an array
      var valArr = values.split(",");
      // Check if it contains the passed value
      var isOption = $.inArray(value, valArr);
      if (isOption === -1) {
        // Fill this array with the values to be removed from DOM
        removedProductIds.push($(this).data("product-id"));
      }
    });

    // Add some references to the cloned tag that was passed (if)
    if (newTag !== null) {
      newTag.attr("data-removed", removedProductIds).attr("data-type", type);
    }

    // Remove the products from the DOM
    _.map(removedProductIds, function (id) {
      $(".product__root[data-product-id=" + id + "]").remove();
    });

    // If color, find & select those colors
    if (type === "color") {
      $('.product__swatch[data-value="' + value + '"]').trigger("click");
    }
  },
  runBraSizeFilter: function runBraSizeFilter(type, band, cup, newTag) {
    var viableProductIds = [];
    // Create a ref selector for product variants of this band, cup size && are in stock
    var ref =
      '.variant__reference[data-available="true"][data-option2="' +
      band +
      '"][data-option3="' +
      cup +
      '"]';
    $(ref).each(function () {
      // Grab the top level color values
      viableProductIds.push($(this).data("variant-of"));
    });
    // Remove duplicated from viable list of products
    uniqueViableProducts = _.uniq(viableProductIds);

    // Compare viable products to all current products
    var removedProductIds = _.difference(
      collection.allCurrentIds,
      uniqueViableProducts
    );

    // Add some references to the cloned tag that was passed (if)
    if (newTag !== null) {
      newTag.attr("data-removed", removedProductIds).attr("data-type", type);
    }

    // Remove the difference between these two arrays from the DOM
    _.map(removedProductIds, function (id) {
      $(".product__root[data-product-id=" + id + "]").remove();
    });
  },
  onDeselectFilterTag: function onDeselectFilterTag() {
    $(document).on("click", ".filter__bubble", function (event) {
      // Grab it's type
      var type = $(this).data("type");
      // Deselect dropdown options of this type
      $(
        ".desktop__filter__option[data-filter-type='" + type + "']"
      ).removeClass("selected");
      // Remove the tag
      $(this).remove();
      // Reset the collection
      collection.resetCollection();
      // Look for any tags that are still applied & find what they initially removed from the DOM
      var removedProductIds = [];
      $(".product__filters__applied > .is__clone").each(function () {
        var refProducts = $(this).data("removed");
        if (refProducts !== undefined) {
          if (typeof refProducts === "number") {
            removedProductIds.push(refProducts.toString());
          }
          if (typeof refProducts === "string") {
            var valArr = refProducts.split(",");
            _.map(valArr, function (val) {
              removedProductIds.push(val);
            });
          }
        }
      });
      // Remove the products referenced by the remaining tags
      _.map(removedProductIds, function (id) {
        $(".product__root[data-product-id=" + id + "]").remove();
      });

      // Check if it was the last filter tag (Hidden clone counts as 1)
      if ($(".product__filters__applied").children().length === 1) {
        // If so, hide the clear all btn
        $(".product__filters__remove").addClass("display__none");

        // Scroll reset
        collection.resetScroll();
      }
    });
  },
  onDesktopClearFilters: function onDesktopClearFilters() {
    $(".product__filters__remove").on("click", function (event) {
      // Hide the button again
      $(this).addClass("display__none");
      // Remove tag clones
      $(".product__filters__applied > .is__clone").remove();
      // Reset the selected filters in dropdown
      $(".desktop__filter__option").removeClass("selected");
      // Reset the initial view
      collection.resetCollection();
      collection.resetScroll();
    });
  },
  checkForEmptyResults: function checkForEmptyResults() {
    var results = $(".product__root").length;
    if (results === 0) {
      collection.showEmptyMessage();
    }
  },
  showEmptyMessage: function showEmptyMessage() {
    $(".no__results").removeClass("display__none");
  },
  onSwatchSelect: function onSwatchSelect() {
    $(document).on(
      "click",
      ".collection__product__colors > .product__swatch",
      function (event) {
        var productId = $(this).data("swatch-for");
        if ($(this).hasClass("selected")) {
          return null;
        } else {
          // Update href
          collection.replaceUrlParams(productId, $(this).data("value"));
          // Deselect the enabled swatch
          $("div[data-swatch-for = " + productId + "]").removeClass("selected");
          // Enable this one
          $(this).addClass("selected");
          // Reset the quick-add window
          $("div").removeClass("quick-add-enabled");
          // Set the current color
          collection.activeProductColor = $(this).data("value");
          // Replace Main Image
          var mainSrc = $(
            'div[data-type="main"][data-color="' +
              collection.activeProductColor.toLowerCase() +
              '"][data-img-for="' +
              productId +
              '"]'
          ).data("src");

          $(
            '.product__root[data-product-id="' +
              productId +
              '"] > .product__image__wrap > .main'
          ).css("background", 'url("' + mainSrc + '")');

          // Replace 3d Image
          var threeSrc = $(
            'div[data-type="3d"][data-color="' +
              collection.activeProductColor.toLowerCase() +
              '"][data-img-for="' +
              productId +
              '"]'
          ).data("src");

          $(
            '.product__root[data-product-id="' +
              productId +
              '"] > .product__image__wrap > .three-d'
          ).css("background", 'url("' + threeSrc + '")');
        }
      }
    );
  },
  onAddToCartClick: function onAddToCartClick() {
    $(document).on("click", ".collection__product__ready > a", function () {
      var id = collection.activeVariantId;
      var qty = 1;
      var title = $(
        ".title__string__ref[data-product-id='" +
          collection.activeProductId +
          "']"
      ).data("title");
      collection.startLoadingState();
      cart.startLoadingState();
      cart.setAnimationText(title, collection.activeProductId);
      cart.addItem(id, qty, false);
    });
  },
  resetCollection: function resetCollection() {
    // Reset the initial view
    var freshClone = collection.rootClone.clone();
    $(".collection__listing__root").empty().append(freshClone);
  },
  replaceUrlParams: function replaceUrlParams(id, color) {
    var current = $('a[data-link-id="' + id + '"]').attr("href");
    var updated = current.split("=")[0];
    updated = updated + ("=" + color.toLowerCase());
    $('a[data-link-id="' + id + '"]').attr("href", updated);
  },
  resetScroll: function resetScroll() {
    $("html, body").scrollTo(".scrollTarget", 500, { offset: -60 });
  },
  startLoadingState: function startLoadingState() {
    $(".product__quick__window, .collection__quick__add__modal__root").addClass(
      "loading"
    );
  },
  finishLoadingState: function finishLoadingState() {
    $(
      ".product__quick__window, .collection__quick__add__modal__root"
    ).removeClass("loading");
    $("div").removeClass("quick-add-enabled");
  },
  openFilterModal: function openFilterModal() {
    $(".collection__filter__modal__root, .modal__mask").removeClass(
      "display__none"
    );
    site.lockBodyScroll();
  },
  closeFilterModal: function closeFilterModal() {
    $(".collection__filter__modal__root, .modal__mask").addClass(
      "display__none"
    );
    site.unlockBodyScroll();
  },
  openQuickModal: function openQuickModal() {
    $(".collection__quick__add__modal__root, .modal__mask").removeClass(
      "display__none"
    );
    // Disable quick-add btn & set initial btn text
    $(".quick__add__to__cart").addClass("disabled");
    $(".quick__add__to__cart > .btn").text("Add to Bag");

    site.lockBodyScroll();
  },
  closeQuickModal: function closeQuickModal() {
    $(".collection__quick__add__modal__root, .modal__mask").addClass(
      "display__none"
    );
    site.unlockBodyScroll();
  },
  enableWindowLoadingIcon: function enableWindowLoadingIcon() {
    $(".loading__root").removeClass("display__none");
    $(
      ".product__quick__window > .inner > .options, .quick__add__to__cart"
    ).addClass("display__none");
  },
  disableWindowLoadingIcon: function disableWindowLoadingIcon() {
    $(".loading__root").addClass("display__none");
    $(
      ".product__quick__window > .inner > .options, .quick__add__to__cart"
    ).removeClass("display__none");
  },
};

("use strict");

var header = {
  init: function init() {
    header.scrollMonitor();
    header.clickListeners();
  },
  scrollMonitor: function scrollMonitor() {
    $(window).scroll(function (event) {
      var scrollPosition = $(window).scrollTop();
      if (scrollPosition > 30) {
        $(".subheader__root, .header__root, .progress-bar").addClass(
          "scrolled"
        );
      } else {
        $(".subheader__root, .header__root, .progress-bar").removeClass(
          "scrolled"
        );
      }
    });
  },
  clickListeners: function clickListeners() {
    header.onBagClick();
    header.onAccountClick();
    header.onSearchClick();
    header.onHamburgerClick();
  },
  updateBagTotal: function updateBagTotal(qty) {
    $(".bag__wrap > .total > span").text(qty);
  },
  onAccountClick: function onAccountClick() {
    $(".header__account").click(function () {
      var isLoggedIn = $(this).data("customer");

      if (isLoggedIn) {
        window.location = "/account";
      } else {
        drawer.showSignIn();
        if (!drawer.isOpen) {
          drawer.open();
        }
      }
    });
  },
  onBagClick: function onBagClick() {
    $(".header__bag, .bag__wrap > .total").click(function () {
      // drawer.showCart();
      // if (!drawer.isOpen) {
      //   drawer.open();
      // }
    });
  },
  onSearchClick: function onSearchClick() {
    $(".header__search").click(function () {
      drawer.showSearch();
      if (!drawer.isOpen) {
        drawer.open();
      }
    });
  },
  onHamburgerClick: function onHamburgerClick() {
    $(".header__logo-hamburger").on("click", function () {
      $(".header__root, .header__hamburger__root").toggleClass(
        "hamburger__open"
      );
    });
  },
};

("use strict");

var drawer = {
  //state
  isOpen: false,
  mode: "cart",

  init: function init() {
    drawer.registerClickEvents();
  },
  registerClickEvents: function registerClickEvents() {
    drawer.onCloseClick();
    drawer.onRegisterFromLoginClick();
    drawer.onBackClick();
    drawer.onRenderedPasswordCTAClick();
    drawer.onForgotClick();
    drawer.onSnizeBackClick();
  },
  onCloseClick: function onCloseClick() {
    $(".drawer__close").on("click", function () {
      drawer.close();
    });
  },
  open: function open() {
    $(".drawer__root, .header__root, .footer__root, #MainContent").addClass(
      "drawer-active"
    );
    drawer.isOpen = true;
    site.lockBodyScroll();
  },
  close: function close() {
    $(".drawer__root, .header__root, .footer__root, #MainContent").removeClass(
      "drawer-active"
    );
    drawer.isOpen = false;
    site.unlockBodyScroll();
  },
  onRegisterFromLoginClick: function onRegisterFromLoginClick() {
    $(".drawer__register").on("click", function () {
      drawer.showRegister();
    });
  },
  onForgotClick: function onForgotClick() {
    $(".drawer__forgot").on("click", function () {
      drawer.showReset();
    });
  },
  onBackClick: function onBackClick() {
    $(".drawer__register__back, .drawer__reset__back").on("click", function () {
      drawer.showSignIn();
    });
  },
  onRenderedPasswordCTAClick: function onRenderedPasswordCTAClick() {
    $(".errors ul > li > a").on("click", function (event) {
      var target = $(this).attr("href");
      if (target === "/account/login#recover") {
        event.preventDefault();
        drawer.showReset();
        return false;
      }
    });
  },
  showCart: function showCart() {
    $(".drawer__account__element").addClass("display__none");
    $(".drawer__search__element").addClass("display__none");
    $(".drawer__cart__root").removeClass("display__none");
  },
  showSignIn: function showSignIn() {
    $(".drawer__account__element").addClass("display__none");
    $(".drawer__search__element").addClass("display__none");
    $(".drawer__sign__in__root").removeClass("display__none");
  },
  showRegister: function showRegister() {
    $(".drawer__account__element").addClass("display__none");
    $(".drawer__search__element").addClass("display__none");
    $(".drawer__register__root").removeClass("display__none");
  },
  showReset: function showReset() {
    $(".drawer__account__element").addClass("display__none");
    $(".drawer__reset__root").removeClass("display__none");
  },
  showResetForm: function showResetForm() {
    $(".drawer__account__element").addClass("display__none");
    $(".drawer__reset__form__root").removeClass("display__none");
  },
  showSuccess: function showSuccess() {
    $(".drawer__account__element").addClass("display__none");
    $(".drawer__success__root").removeClass("display__none");
  },
  showSearch: function showSearch() {
    $(".drawer__account__element").addClass("display__none");
    $(".drawer__search__root").removeClass("display__none");

    if (site.isDesktop) {
      $(".site-nav__search > input").focus();
    }
  },
  onSnizeBackClick: function onSnizeBackClick() {
    $(document).on("click", ".snize-close-button-arrow", function () {
      drawer.close();
    });
  },
};

("use strict");

var helpers = {
  formatLongBubble: function formatLongBubble(value) {
    // If the size in the S (0-2) format, split the space and return the first half of the value
    if (value.length > 3) {
      return value.substr(0, value.indexOf(" "));
    } else {
      return value;
    }
  },
  formatPrice: function formatPrice(raw) {
    var formatted = raw / 100;
    return formatted.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  },
  isMobile: function isMobile() {
    return $(window).width() <= 600;
  },
};

("use strict");

var cart = {
  //state
  currentCart: [],
  currentIds: [],

  init: function init() {
    cart.hideAnimationElements();
    cart.update();
    cart.registerClickEvents();
  },
  registerClickEvents: function registerClickEvents() {
    cart.onRemoveCartVariantClick();
    cart.onChangeCartVariantQtyClick();
  },
  addItem: function addItem(id, qty, shouldTriggerMatching) {
    // Check if item is aready in cart, if so use increment/adjust
    if (cart.currentIds.includes(id)) {
      var obj = _.findWhere(cart.currentCart.items, { variant_id: id });
      var newQty = parseInt(obj.quantity) + 1;
      cart.adjustItem(id, newQty, true, shouldTriggerMatching);
      // Else add it like normal
    } else {
      var data = {
        quantity: qty,
        id: id,
      };

      $.ajax({
        url: "/cart/add.js",
        type: "POST",
        data: data,
        complete: function complete(response) {
          if (response.status == 200) {
            cart.runAddToCartAnimation(shouldTriggerMatching);
            cart.update();
            if (!site.isDesktop) {
              collection.closeQuickModal();
            }
          }
        },
      });
    }
  },

  adjustItem: function adjustItem(
    id,
    qty,
    shouldTriggerAnimation,
    shouldTriggerMatching
  ) {
    $.ajax({
      url: "/cart/update.js",
      type: "POST",
      data: "updates[" + id + "]=" + qty,
      complete: function complete(response) {
        if (response.status == 200) {
          cart.update();
          if (shouldTriggerAnimation) {
            cart.runAddToCartAnimation(shouldTriggerMatching);
            if (!site.isDesktop) {
              collection.closeQuickModal();
            }
          }
        }
      },
    });
  },
  update: function update() {
    $.ajax({
      url: "/cart.js",
      type: "GET",
      complete: function complete(response) {
        response = JSON.parse(response.responseText);
        cart.currentCart = response;
        cart.currentIds = _.pluck(response.items, "id");

        // Run total price & qty update
        cart.updateTotal(response.total_price);
        header.updateBagTotal(response.item_count);

        // Run cart item rendering
        if (response.items.length) {
          cart.renderCartItems(response.items);
          $(".cart__has__items").removeClass("display__none");
          $(".cart__empty").addClass("display__none");
        } else {
          $(".cart__has__items").addClass("display__none");
          $(".cart__empty").removeClass("display__none");
          $(".bag__wrap > .total").addClass("hidden");
          setTimeout(function () {
            $(".bag__wrap > .total").css("opacity", 0);
          }, 500);
        }

        // Exit loading states
        product.finishLoadingState();
        collection.finishLoadingState();
        cart.finishLoadingState();
      },
    });
  },
  updateTotal: function updateTotal(raw) {
    var formatted = helpers.formatPrice(raw);
    $(".checkout__total").text(formatted);
  },
  renderCartItems: function renderCartItems(items) {
    // Get clones
    var braClone = $(".cart__bra__clone")
      .clone()
      .removeClass("display__none")
      .removeClass("cart__bra__clone")
      .addClass("cart__live__clone");
    var undClone = $(".cart__und__clone")
      .clone()
      .removeClass("display__none")
      .removeClass("cart__und__clone")
      .addClass("cart__live__clone");

    // Empty the div of any live clones
    $(".cart__live__clone").remove();

    // Append the new clones
    _.map(items, function (item) {
      // Get the attributes
      var product_title = item.product_title,
        price = item.price,
        variant_id = item.variant_id,
        product_id = item.product_id,
        variant_options = item.variant_options,
        quantity = item.quantity,
        image = item.image,
        handle = item.handle;

      // Determine if it's a bra or und

      var isBra = variant_options.length === 3 ? true : false;

      // Get a proxy clone, determine by # of options
      var proxy = isBra ? braClone.clone() : undClone.clone();

      // Apply title
      proxy
        .find(".title__remove > .left > a > span")
        .text(
          product_title +
            " " +
            $('.title__string__ref[data-product-id="' + product_id + '"]').data(
              "subtitle"
            )
        );

      // Apply title link
      proxy
        .find(".title__remove > .left > a ")
        .attr("href", "/products/" + handle);

      // Apply price
      proxy
        .find(".count__total > .right > span")
        .text(helpers.formatPrice(price));

      // Apply qty
      proxy.find(".qty > span").text(quantity);

      // Apply color
      proxy.find(".opt1").text(variant_options[0]);

      // Apply img
      proxy.find(".image > img").attr("src", image);

      // Apply links
      proxy
        .find(".image > a, .title__remove > .left > a ")
        .attr("href", "/products/" + handle);

      // Apply sizes
      if (isBra) {
        proxy.find(".band").text(variant_options[1]);
        proxy.find(".cup").text(variant_options[2]);
      } else {
        proxy.find(".und").text(variant_options[1]);
      }

      // Append data attrs for click events on each clone
      proxy
        .find(".cart__trash, .more, .less")
        .attr("data-variant-id", variant_id);

      // Append it to the DOM
      $(".drawer__cart__root > .content").append(proxy);
    });
  },
  deleteCartVariant: function deleteCartVariant(id) {
    cart.startLoadingState();
    cart.adjustItem(id, 0);
  },
  changeCartVariantQty: function changeCartVariantQty(id, qty) {
    cart.startLoadingState();
    cart.adjustItem(id, qty);
  },
  onRemoveCartVariantClick: function onRemoveCartVariantClick() {
    $(document).on("click", ".cart__trash", function (event) {
      var id = $(this).data("variant-id");
      cart.deleteCartVariant(id);
    });
  },
  onChangeCartVariantQtyClick: function onChangeCartVariantQtyClick() {
    $(document).on("click", ".cart__change__qty", function (event) {
      var id = $(this).data("variant-id");
      var increment = $(this).hasClass("more");
      var currentQty = $(this).parent().find(".qty").text();
      var newQty = void 0;
      if (increment) {
        newQty = parseInt(currentQty) + 1;
      } else {
        newQty = parseInt(currentQty) - 1;
      }
      // Run the API call
      cart.changeCartVariantQty(id, newQty);
    });
  },
  startLoadingState: function startLoadingState() {
    $(".drawer__cart__root").addClass("loading");
  },
  finishLoadingState: function finishLoadingState() {
    $(".drawer__cart__root").removeClass("loading");
  },
  hideAnimationElements: function hideAnimationElements() {
    $(".after__cart__add").css("opacity", 0);
    var qtyIsHidden = $(".bag__wrap > .total").hasClass("hidden");
    if (qtyIsHidden) {
      $(".bag__wrap > .total").css("opacity", 0);
    }
  },
  setAnimationText: function setAnimationText(title, id) {
    var subtitle = $('.title__string__ref[data-product-id="' + id + '"]').data(
      "subtitle"
    );

    var string = site.isMobile ? title : title + " " + subtitle;
    $(".after__cart__add > p > span").text(string);
  },
  runAddToCartAnimation: function runAddToCartAnimation(shouldTriggerMatching) {
    // Check if the bubble is hidden
    var qtyIsHidden = $(".bag__wrap > .total").hasClass("hidden");
    if (qtyIsHidden) {
      $(".bag__wrap > .total").removeClass("hidden");
    }
    $(".after__cart__add, .bag__wrap > .total").css("opacity", 1);
    $(".after__cart__add").addClass("shown");
    // Set a timer to shift to the second part of the animation
    setTimeout(function () {
      $(".after__cart__add").removeClass("shown");
      // Check if there's a matching product & they're not coming from it's match
      var hasMatch = $(".product__matching__root");
      var isUserMatching = site.getUrlParams("matching") === "1";
      //console.log(site.getUrlParams("matching"));
      if (hasMatch.length && !isUserMatching) {
        if (shouldTriggerMatching) {
          $(".product__matching__root").addClass("shown");
        }
      }
    }, 1500);
    setTimeout(function () {
      $(".after__cart__add").css("opacity", 0);
    }, 2000);
  },
};

("use strict");

var validation = {
  init: function init() {
    validation.initSettings();
    validation.setListeners();
  },

  setListeners: function setListeners() {
    validation.onSignIn();
    validation.onModalSignIn();
    validation.onRegister();
    validation.onRecoverEmail();
    validation.onPasswordReset();
    validation.onNotifyMe();
  },
  initSettings: function initSettings() {
    $(".product__reviews__editor__form").validate({
      errorPlacement: function errorPlacement(error, element) {
        return false;
      },
    });
    $("#create_customer").validate({
      errorPlacement: function errorPlacement(error, element) {
        return false;
      },
      rules: {
        ConfirmPassword: {
          equalTo: "#CreatePassword",
        },
      },
    });
    $("#customer_login").validate({
      errorPlacement: function errorPlacement(error, element) {
        return false;
      },
    });
    $("#customer_login_guest").validate({
      errorPlacement: function errorPlacement(error, element) {
        return false;
      },
    });
    $("#notifyForm").validate({
      errorPlacement: function errorPlacement(error, element) {
        return false;
      },
    });
    // Give this a class because for whatever reason its not provided by shopify
    $("#recover__form > form").addClass("recover__form");
    $(".recover__form").validate({
      errorPlacement: function errorPlacement(error, element) {
        return false;
      },
    });
  },
  onSignIn: function onSignIn() {
    $("#customer_login").on("submit", function (e) {
      if ($("#SignInEmail").valid()) {
        $(".sign__in__email").removeClass("field__invalid");
      } else {
        $(".sign__in__email").addClass("field__invalid");
      }
    });
  },
  onModalSignIn: function onModalSignIn() {
    $("#customer_login_guest").on("submit", function (e) {
      if ($("#ModalSignInEmail").valid()) {
        $(".modal__sign__in__email").removeClass("field__invalid");
      } else {
        $(".modal__sign__in__email").addClass("field__invalid");
      }
    });
  },
  onRegister: function onRegister() {
    $("#create_customer").on("submit", function (e) {
      if ($("#RegisterEmail").valid()) {
        $(".register__email").removeClass("field__invalid");
      } else {
        $(".register__email").addClass("field__invalid");
      }
    });
  },
  onRecoverEmail: function onRecoverEmail() {
    $("#RecoverEmail").keyup(function (e) {
      if ($("#RecoverEmail").valid() == true) {
        $(".recover__email").removeClass("field__invalid");
      } else {
        $(".recover__email").addClass("field__invalid");
      }
    });
  },
  onPasswordReset: function onPasswordReset() {
    $("#PasswordConfirmation").keyup(function (e) {
      if ($("#PasswordConfirmation").val() === $("#ResetPassword").val()) {
        $(".pass__confirm").removeClass("field__invalid");
        $(".pass__confirm__btn").removeClass("disabled");
      } else {
        $(".pass__confirm").addClass("field__invalid");
        $(".pass__confirm__btn").addClass("disabled");
      }
    });
  },
  onNotifyMe: function onNotifyMe() {
    $("#notifyEmail").keyup(function (e) {
      if ($("#notifyEmail").valid() == true) {
        $(".notify__form__wrap").removeClass("form__invalid");
      } else {
        $(".notify__form__wrap").addClass("form__invalid");
      }
    });
  },
};

("use strict");

var fitOpts = [
  "30B",
  "30A",
  "30AA",
  "30AAA",
  "32B",
  "32A",
  "32AA",
  "32AAA",
  "34B",
  "34A",
  "34AA",
  "34AAA",
  "36B",
  "36A",
  "36AA",
  "36AAA",
  "38B",
  "38A",
  "38AA",
  "38AAA",
];

// Goes out of range on purpose as final calculations can be within fitOpts
var cupSize = {
  AAAAAA: 0,
  AAAAA: 1,
  AAAA: 2,
  AAA: 3,
  AA: 4,
  A: 5,
  B: 6,
  C: 7,
  D: 8,
};

// Goes out of range on purpose as final calculations can be within fitOpts
var bandSize = {
  28: 0,
  30: 1,
  32: 2,
  34: 3,
  36: 4,
  38: 5,
  40: 6,
};

var fit = {
  // state
  stepTwoActive: false,
  currSlide: 0,
  initialBandSize: null,
  initialCupSize: null,
  cupFit: null,
  bandFit: null,
  variantId: "",
  modalActive: false,
  animation: null,
  init: function init() {
    fit.registerClickEvents();
    $(".button__wrapper").hide();
    $(".bra-fitting-wrap").css("display", "flex");
  },
  runLogoAnimation: function runLogoAnimation() {
    fit.animation = bodymovin
      .loadAnimation({
        container: document.getElementById("fit-logo__animation"),
        renderer: "svg",
        loop: false,
        autoplay: true,
        path: "https://cdn.shopify.com/s/files/1/0027/8134/7953/files/fit-logo.json?8257123860119664332",
      })
      .setSpeed(1.25);
  },
  hideLauncher: function hideLauncher() {
    zE("webWidget", "hide");
  },
  showLauncher: function showLauncher() {
    zE("webWidget", "show");
  },
  registerClickEvents: function registerClickEvents() {
    $(".trigger-fit").on("click", function (e) {
      e.preventDefault();
      // fit.hideLauncher();
      fit.start();
    });
    $(".band-item").each(function (band) {
      $(this).on("click", function (e) {
        if (this.classList.contains("fit_content_active")) {
          $(this).removeClass("fit_content_active");
          fit.initialBandSize = null;
          fit.displayNextButton(fit.currSlide);
        } else {
          var bandSize = Number(this.innerHTML);
          $(this)
            .addClass("fit_content_active")
            .siblings(".band-item")
            .removeClass("fit_content_active");
          fit.initialBandSize = bandSize;
          fit.displayNextButton(fit.currSlide);
        }
      });
    });
    $(".cup-item").each(function (cup) {
      $(this).on("click", function (e) {
        if (this.classList.contains("fit_content_active")) {
          $(this).removeClass("fit_content_active");
          fit.initialCupSize = null;
          fit.displayNextButton(fit.currSlide);
        } else {
          var cupSize = this.innerHTML;
          $(this)
            .addClass("fit_content_active")
            .siblings(".cup-item")
            .removeClass("fit_content_active");
          fit.initialCupSize = cupSize;
          fit.displayNextButton(fit.currSlide);
        }
      });
    });
    $(".fit-container-cup").each(function (item) {
      $(this).on("click", function (e) {
        var cupSelected = $(this).find(".cup_fit")[0];
        var checkMark = $(cupSelected).prev().find(".checked-item-cup");
        if (cupSelected.classList.contains("fit_content_active")) {
          $(cupSelected).removeClass("fit_content_active");
          checkMark.css("visibility", "hidden");
          fit.cupFit = null;
          fit.displayNextButton(fit.currSlide);
        } else {
          var cupFit = this.innerText;
          var cupSelected = $(this).find(".cup_fit")[0];
          $(cupSelected).addClass("fit_content_active");
          checkMark.css("visibility", "visible");
          $(".checked-item-cup").not(checkMark).css("visibility", "hidden");
          $(".cup_fit").not(cupSelected).removeClass("fit_content_active");
          fit.getCupSize(cupSelected.id);
          fit.displayNextButton(fit.currSlide);
        }
      });
    });
    $(".fit-container-band").each(function (item) {
      $(this).on("click", function (e) {
        var bandSelected = $(this).find(".band_fit")[0];
        var checkMark = $(bandSelected).prev().find(".checked-item-band");
        if (bandSelected.classList.contains("fit_content_active")) {
          $(bandSelected).removeClass("fit_content_active");
          checkMark.css("visibility", "hidden");
          fit.bandFit = null;
          fit.displayNextButton(fit.currSlide);
        } else {
          var bandFit = this.innerText;
          $(bandSelected).addClass("fit_content_active");
          checkMark.css("visibility", "visible");
          $(".checked-item-band").not(checkMark).css("visibility", "hidden");
          $(".band_fit").not(bandSelected).removeClass("fit_content_active");
          fit.getBandSize(bandSelected.id);
          fit.displayNextButton(fit.currSlide);
        }
      });
    });
    $(".button__wrapper .button").on("click", function (e) {
      e.preventDefault();
      fit.goTo(fit.currSlide, $(this));
    });
    $(".modal-trigger").on("click", function (e) {
      e.preventDefault();
      $(".modal--bra-mailer").removeClass("fadeOut").addClass("fadeIn");
      fit.modalActive = true;
    });
    $(".modal__close").on("click", function (e) {
      if (fit.modalActive) {
        $(".modal--bra-mailer").removeClass("fadeIn").addClass("fadeOut");
        fit.modalActive = false;
      }
    });
    $("#restart").on("click", function (e) {
      e.preventDefault();
      if (!site.isDesktop) {
        site.unLockTouchMove();
      }
      (fit.initialBandSize = null),
        (fit.initialCupSize = null),
        (fit.cupFit = null),
        (fit.bandFit = null),
        $(".step__five").removeClass("fadeIn results loading error");
      $(".step__five").parent().css("height", "auto");
      $(".step__five").addClass("fadeOut");
      $(".collection__link").show();
      $(".your__size").text(
        "Based on your selections, we need a little bit more information."
      );
      $("#restart")
        .removeClass("btn btn-primary")
        .addClass("link link__underline");
      $(".your__size").text("Your bra size is:");
      $("*").removeClass("fit_content_active footer-active");
      $("body").removeClass("bra-fit-results");
      $(".checked-item-cup,.checked-item-band").css("visibility", "hidden");
      $(".header__root").removeClass("header_background");
      $(".subheader__root").removeClass("result-subheader");
      $("#fit-logo__animation").children().remove();
      if (site.isMobile) {
        $(".result-links").removeClass("mobile");
      }
      $(".subheader__root a").removeClass("result-links");
      fit.start();
    });
  },
  start: function start() {
    $(".bra-fitting-wrap").css("display", "none");
    $(".step__one").addClass("fadeOut");
    $(".step__two").addClass("fadeIn");
    $(".button__wrapper").show();
    $(".button__wrapper").css("opacity", "1");
    $(".back-button-wrapper").css("opacity", "1");
    $(".button").css("pointer-events", "auto");
    fit.currSlide = 1;
    fit.updateProgress(fit.currSlide);
    fit.displayNextButton(fit.currSlide);
  },
  goTo: function goTo(currSlide, that) {
    var nextSlide = void 0;
    var action = that.data("step");
    if (action == "next") {
      nextSlide = currSlide + 1;
    } else {
      nextSlide = currSlide - 1;
    }
    fit.currSlide = nextSlide;
    fit.updateSlide();
    fit.displayNextButton(fit.currSlide);
  },
  updateSlide: function updateSlide() {
    if (fit.currSlide == 0) {
      $(".bra-fitting-wrap").css("display", "flex");
      $(".bra-fitting").removeClass("fadeIn");
      $(".step__one").removeClass("fadeOut");
      $(".step__one").addClass("fadeIn");
      $("#launcher").css("visibility", "visible");
      $(".button__wrapper").hide();
      $(".button__wrapper").css("opacity", "0");
      $(".button").css("pointer-events", "none");
      fit.showLauncher();
    } else if (fit.currSlide == 1) {
      // fit.hideLauncher();
      $(".bra-fitting-wrap").css("display", "none");
      $(".button__wrapper").show();
      $(".button__wrapper").css("opacity", "1");
      $(".button").css("pointer-events", "auto");
      $(".bra-fitting").removeClass("fadeIn");
      $(".step__one").addClass("fadeOut");
      $(".step__one").removeClass("fadeIn");
      $(".step__two").addClass("fadeIn");
    } else if (fit.currSlide == 2) {
      $(".bra-fitting").removeClass("fadeIn");
      $(".step__one").addClass("fadeOut");
      $(".step__two").addClass("fadeOut");
      $(".step__three").addClass("fadeIn");
    } else if (fit.currSlide == 3) {
      $(".bra-fitting").removeClass("fadeIn");
      $(".step__one").addClass("fadeOut");
      $(".step__two").addClass("fadeOut");
      $(".step__three").addClass("fadeOut");
      $(".step__four").addClass("fadeIn");
    } else if (fit.currSlide == 4) {
      fit.calculateBraSize();
      $(".bra-fitting").removeClass("fadeIn");
      $(".step__four").addClass("fadeOut");
      $("body").addClass("bra-fit-results");
      $(".step__five").parent().css("height", "100vh");
      $(".step__five").addClass("loading");
      $(".button__wrapper").css("opacity", "0");
      fit.runLogoAnimation();
    }
    window.scrollTo(0, 0);
    fit.updateProgress(fit.currSlide);
  },
  calculateBraSize: function calculateBraSize() {
    var totalSize = fit.bandFit + fit.cupFit;
    setTimeout(function () {
      if (fitOpts.includes(totalSize)) {
        var cupSize = fit.cupFit;
        var bandSize = fit.bandFit;
        var url =
          "/collections/bras?bandSize=" + bandSize + "&cupSize=" + cupSize;
        $(".calculated-bra-size").text(totalSize);
        $(".step__five .collection__link").attr("href", url);
        $(".header__root").addClass("header_background");
        $(".subheader__root").addClass("result-subheader");
        $(".subheader__root a").addClass("result-links");
        if (site.isMobile) {
          $(".result-links").addClass("mobile");
        }
        $(".step__five").addClass("fadeIn");
        $(".progress-bar").removeClass("one two three four five");
        $(".background svg").css("display", "block");
        if (!site.isDesktop) {
          site.lockTouchMove();
        }
      } else {
        $(".step__five").addClass("error");
        $(".collection__link").hide();
        $(".link__underline")
          .removeClass("link link__underline ")
          .addClass("btn btn-primary");
        $(".your__size").text(
          "Based on your selections, we need a little bit more information."
        );
        $(".progress-bar").removeClass("one two three four five");
      }
    }, 2000);
  },
  getCupSize: function getCupSize(cup) {
    var currentCupNumber = cupSize[fit.initialCupSize];
    var newCupNumber;
    var newCupSize;
    switch (cup) {
      case "cup-1": // bulging out
        newCupNumber = currentCupNumber + 1;
        newCupSize = Object.keys(cupSize).find(
          (key) => cupSize[key] === newCupNumber
        );
        break;
      case "cup-2": // perfect
        newCupSize = fit.initialCupSize;
        break;
      case "cup-3": // slight gapping
        newCupNumber = currentCupNumber - 1;
        newCupSize = Object.keys(cupSize).find(
          (key) => cupSize[key] === newCupNumber
        );
        break;
      case "cup-4": // I can swim
        newCupNumber = currentCupNumber - 2;
        newCupSize = Object.keys(cupSize).find(
          (key) => cupSize[key] === newCupNumber
        );
        break;
    }
    fit.cupFit = newCupSize;
  },
  getBandSize: function getBandSize(band) {
    var currentCupNumber = cupSize[fit.cupFit];
    var currentBandNumber = bandSize[fit.initialBandSize];
    var newCupNumber;
    var newBandNumber;
    var newCupSize;
    var newBandSize;
    switch (band) {
      case "band-1": // too tight
        newBandNumber = currentBandNumber + 1;
        newCupNumber = currentCupNumber - 1;
        newCupSize = Object.keys(cupSize).find(
          (key) => cupSize[key] === newCupNumber
        );
        newBandSize = Object.keys(bandSize).find(
          (key) => bandSize[key] === newBandNumber
        );
        break;
      case "band-2": // comfort
        newCupSize = fit.cupFit;
        newBandSize = fit.initialBandSize;
        break;
      case "band-3": // loose
        newBandNumber = currentBandNumber - 1;
        newCupNumber = currentCupNumber + 1;
        newCupSize = Object.keys(cupSize).find(
          (key) => cupSize[key] === newCupNumber
        );
        newBandSize = Object.keys(bandSize).find(
          (key) => bandSize[key] === newBandNumber
        );
        break;
    }
    fit.cupFit = newCupSize;
    fit.bandFit = newBandSize;
  },
  updateProgress: function updateProgress(currSlide) {
    var progressClass;
    switch (currSlide) {
      case 1:
        progressClass = "one";
        break;
      case 2:
        progressClass = "two";
        break;
      case 3:
        progressClass = "three";
        break;
      case 4:
        progressClass = "four";
        break;
    }
    $(".progress-bar").removeClass("one two three four");
    $(".progress-bar").addClass(progressClass);
  },
  onAddToCartClick: function onAddToCartClick() {
    $(document).on("click", ".mailer-product__ready", function (e) {
      // e.preventDefault();
      var id = $(this).data("variantId");
      var qty = 1;
      $(".modal--bra-mailer").addClass("fadeOut");
      // collection.startLoadingState();
      cart.startLoadingState();

      cart.addItem(id, qty);
    });
  },
  displayNextButton: function displayNextButton(currSlide) {
    switch (currSlide) {
      case 1:
        if (fit.initialBandSize !== null && fit.initialCupSize !== null) {
          $(".button__wrapper").addClass("footer-active");
          $(".back-button-wrapper").addClass("back-button-active");
          $("#next").html("Next");
        } else {
          $(".button__wrapper").removeClass("footer-active");
          $(".back-button-wrapper").removeClass("back-button-active");
          $("#next").html("Next");
        }
        break;
      case 2:
        if (fit.cupFit !== null) {
          $(".button__wrapper").addClass("footer-active");
          $(".back-button-wrapper").addClass("back-button-active");
          $("#next").html("Next");
        } else {
          $(".button__wrapper").removeClass("footer-active");
          $(".back-button-wrapper").removeClass("back-button-active");
          $("#next").html("Next");
        }
        break;
      case 3:
        if (fit.bandFit !== null) {
          $(".button__wrapper").addClass("footer-active");
          $(".back-button-wrapper").addClass("back-button-active");
          $("#next").html("Calculate Bra Size");
        } else {
          $(".button__wrapper").removeClass("footer-active");
          $(".back-button-wrapper").removeClass("back-button-active");
          $("#next").html("Next");
        }
        break;
    }
  },
};

("use strict");

var account = {
  init: function init() {
    if (
      window.location.pathname === "/account" ||
      window.location.pathname === "/account/addresses"
    ) {
      account.registerClickEvents();
      account.checkUrls();
    }
  },
  registerClickEvents: function registerClickEvents() {
    account.onEditSectionClick();
    account.onListMenuClick();
    account.onAccountBackClick();
    account.onAccountBackOrderClick();
    account.onChooseAddAddressClick();
    account.onCancelAddAddressClick();
    account.onChooseEditAddressClick();
    account.onReturnClick();
    account.onExpandOrderClick();
  },
  checkUrls: function checkUrls() {
    var hash = location.hash;
    if (window.location.pathname === "/account/addresses") {
      account.showAddresses();
      $('h3[data-hash="#addresses"]').addClass("active");
      return;
    }
    if (hash) {
      $('h3[data-hash="' + hash + '"]').addClass("active");
    }
    switch (hash) {
      case "#profile":
        account.showProfile();
        break;
      case "#orders":
        account.showOrders();
        $(".account__content__root").addClass("order__view");
        break;
      case "#addresses":
        account.showAddresses();
        break;
      case "#rewards":
        account.showRewards();
        break;
      case "#payment":
        account.showPayment();
        break;
      default:
        if (!site.isMobile) {
          account.showProfile();
          $('h3[data-hash="#profile"]').addClass("active");
        }
    }
  },
  onEditSectionClick: function onEditSectionClick() {
    $(".account__profile__reset").on("click", function (e) {
      drawer.showSignIn();
      drawer.showReset();
      drawer.open();
    });
  },
  onListMenuClick: function onListMenuClick() {
    $(".account__menu__root > .list__menu > h3").on("click", function (e) {
      var hash = $(this).data("hash");
      if (hash) {
        $(this).parent().children().removeClass("active");
        // Set the view width
        $(".account__content__root").removeClass("order__view");
        // Default to normal order view
        account.hideExpandedOrder();
        $(this).addClass("active");
        switch (hash) {
          case "#profile":
            account.showProfile();
            break;
          case "#orders":
            $(".account__content__root").addClass("order__view");
            account.showOrders();
            break;
          case "#addresses":
            account.showAddresses();
            break;
          case "#rewards":
            account.showRewards();
            break;
          case "#payment":
            account.showPayment();
            break;
          default:
            account.showProfile();
        }
        // Update the URL
        history.pushState(hash, null, "/account" + hash);

        // Reset edit screens
        $(".account__body__section > .static").removeClass("display__none");
        $(
          ".account__body__section > .edit, .account__address__cancel"
        ).addClass("display__none");
        account.showAddressRoot();
      } else {
        window.location = "account/logout";
      }
    });
  },
  onReturnClick: function onReturnClick() {
    $(".account__return__request").on("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var id = $(this).data("id");
      var zip = $(this).data("zip") + "";
      var url = "https://api.loopreturns.com/api/v1/order/link";
      var payload = {
        designation: 794,
        name: id,
        zip: zip,
      };

      var reqHeaders = new Headers({
        "content-type": "application/json",
        "x-authorization": "bff6f40cd06b7d3ad9826bbeb1c485ae85aa6d81",
      });

      fetch(url, {
        method: "post",
        headers: reqHeaders,
        mode: "cors",
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          console.log(response);
          return response.json();
        })
        .then(function (data) {
          window.location = data.url;
        })
        .catch(function (err) {
          window.location = "https://lulalu.loopreturns.com";
        });
    });
  },
  onExpandOrderClick: function onExpandOrderClick() {
    $(".return__details > .view").on("click", function (e) {
      var id = $(this).data("for");
      // open order & hide other els
      account.showExpandedOrder(id);
    });
  },
  showProfile: function showProfile() {
    $(".account__body__section").addClass("display__none");
    $(".account__profile__root").removeClass("display__none");
    $(".account__page__target").text("My Profile");
    $(
      ".account__body__root, .account__menu__root, .account__heading__root"
    ).addClass("page__selected");
  },
  showRewards: function showRewards() {
    $(".account__body__section").addClass("display__none");
    $(".swell-account-page").removeClass("display__none");
    $(".account__page__target").text("My Rewards");
    $(
      ".account__body__root, .account__menu__root, .account__heading__root"
    ).addClass("page__selected");
  },
  showOrders: function showOrders() {
    $(".account__body__section").addClass("display__none");
    $(".account__orders__root").removeClass("display__none");
    $(".account__page__target").text("Order History");
    $(
      ".account__body__root, .account__menu__root, .account__heading__root"
    ).addClass("page__selected");
  },
  showAddresses: function showAddresses() {
    $(".account__body__section").addClass("display__none");
    $(".account__address__root").removeClass("display__none");
    $(".account__page__target").text("My Addresses");
    $(
      ".account__body__root, .account__menu__root, .account__heading__root"
    ).addClass("page__selected");
  },
  showAddressRoot: function showAddressRoot() {
    $(".account__address__wrap, .account__add__address").removeClass(
      "display__none"
    );
    $(".account__address__wrap").removeClass("edit__enabled");
    $("#AddressNewForm, .address__edit__form").addClass("display__none");
  },
  onChooseAddAddressClick: function onChooseAddAddressClick() {
    $(".account__add__address").on("click", function () {
      $(".account__address__cancel").removeClass("display__none");
      account.showAddressAddForm();
    });
  },
  onCancelAddAddressClick: function onCancelAddAddressClick() {
    $(".account__address__cancel").on("click", function (e) {
      $(this).addClass("display__none");
      account.showAddressRoot();
    });
  },
  showAddressAddForm: function showAddressAddForm() {
    $(".account__address__wrap, .account__add__address").addClass(
      "display__none"
    );
    $("#AddressNewForm").removeClass("display__none");
  },
  onChooseEditAddressClick: function onChooseEditAddressClick() {
    $(".address-edit-toggle").on("click", function (e) {
      var id = $(this).data("form-id");
      account.showAddressEditForm(id);
    });
  },
  showAddressEditForm: function showAddressEditForm(id) {
    $(".account__address__wrap").addClass("edit__enabled");
    $(".account__address__cancel").removeClass("display__none");
    $(".account__add__address").addClass("display__none");
    $('.address__edit__form[data-edit-id="' + id + '"]').removeClass(
      "display__none"
    );
  },
  showPayment: function showPayment() {
    $(".account__body__section").addClass("display__none");
    $(".account__payment__root").removeClass("display__none");
    $(".account__page__target").text("Payment Info");
    $(
      ".account__body__root, .account__menu__root, .account__heading__root"
    ).addClass("page__selected");
  },
  onAccountBackClick: function onAccountBackClick() {
    $(".account__back").on("click", function () {
      $("div").removeClass("page__selected");
    });
  },
  onAccountBackOrderClick: function onAccountBackOrderClick() {
    $(".account__back__order").on("click", function () {
      $(".account__page__target").text("Orders");
      account.hideExpandedOrder();
    });
  },
  showExpandedOrder: function showExpandedOrder(id) {
    $(".account__orders__heading__root, .account__orders__body").addClass(
      "display__none"
    );
    $('.account__single__expanded[data-id="' + id + '"]').removeClass(
      "display__none"
    );
    $(".account__heading__root").addClass("order__selected");
    $(".account__page__target").text("Order No. " + id);
  },
  hideExpandedOrder: function hideExpandedOrder() {
    $(".account__orders__heading__root, .account__orders__body").removeClass(
      "display__none"
    );
    $(".account__single__expanded").addClass("display__none");
    $("div").removeClass("order__selected");
  },
};

("use strict");

var klaviyoConfig = {
  key: "L94UwC",
  url: "https://us-central1-dazzling-being-221123.cloudfunctions.net/klaviyo-back-in-stock1",
};

var klaviyo = {
  init: function init() {
    klaviyo.registerClickEvents();
  },
  registerClickEvents: function registerClickEvents() {
    klaviyo.onNotifyClick();
  },
  onNotifyClick: function onNotifyClick() {
    $("#notifySubmit").on("click", function (e) {
      e.preventDefault();
      if ($("#notifyEmail").valid() == true) {
        $(".product__notify__modal__root > .modal > .inner").addClass(
          "loading"
        );

        // Build query
        var email = $("#notifyEmail").val();
        var id = $(this).data("id");
        var data = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: "$shopify:::$default:::" + id,
                },
              },
            },
          },
        };

        $.ajax({
          type: "POST",
          url: "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=L94UwC",
          data: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
            revision: "2024-07-15",
            accept: "application/json",
          },
          success: function success(response) {
            klaviyo.backInStockSuccess();
          },
        });
      }
    });
  },
  backInStockSuccess: function backInStockSuccess() {
    $(".product__notify__modal__root > .modal").addClass("success");
    $(".product__notify__modal__root > .modal > .inner").remove();
  },
};

("use strict");

var scroller = {
  init: function init() {
    scroller.registerClickEvents();
  },
  registerClickEvents: function registerClickEvents() {
    $(".section-nav__item").on("click", function (e) {
      e.preventDefault();
      var section = $(this).data("section");
      scroller.scrollToSection(section);
    });
    $(".faq__nav-mobile").on("change", function (e) {
      var section = e.target.selectedOptions[0].dataset.section;
      scroller.scrollToSection(section);
    });
  },
  scrollToSection: function scrollToSection(section) {
    var os = 0;
    var scrollTarget = void 0;
    _.each($(".scroll-section"), function (content) {
      if ($(content).data("section") == section) {
        os = $(content).offset().top - 80;
        scrollTarget = $(content);
      }
    });
    $("html, body").scrollTo(scrollTarget, 1000, { offset: -80 });
  },
};

("use strict");

var accordion = {
  init: function init() {
    accordion.registerClickEvents();
    accordion.scrollMonitor();
  },
  registerClickEvents: function registerClickEvents() {
    _.each(
      $(
        ".accordion__item-expandable .block__info-title, .accordion__item-expandable .block__info-title .toggle"
      ),
      function (item) {
        $(item).on("click", function (e) {
          e.stopPropagation();
          $(this)
            .parents(".accordion__item-expandable")
            .toggleClass("expanded");
        });
      }
    );
  },
  scrollMonitor: function scrollMonitor() {
    $(window).scroll(function (event) {
      var scrollPosition = $(window).scrollTop();
      var scrollTarget = site.isMobile ? 275 : 385;
      if (helpers.isMobile()) {
        if (scrollPosition > scrollTarget) {
          $(".section-navigation").addClass("filter__fixed");
        } else {
          $(".section-navigation").removeClass("filter__fixed");
        }
      }
    });
  },
};

("use strict");

var returns = {
  init: function init() {
    returns.registerClickEvents();
  },
  registerClickEvents: function registerClickEvents() {
    var signInBtn = $(".trigger-drawer-account");
    if (signInBtn.length) {
      signInBtn.on("click", function (e) {
        e.preventDefault();
        drawer.showSignIn();
        drawer.open();
      });
    }
  },
};

("use strict");

var yotpoUtil = {
  APP_KEY: "dZpbXqwKzl2vK0zEuMjXURx0QlXd3F2rTZWAfNc3",
  POST_URL: "https://api.yotpo.com/v1/widget/reviews",
  SCORES: [
    "https://cdn.shopify.com/s/files/1/0027/8134/7953/files/review-1.svg?8353109349744174613",
    "https://cdn.shopify.com/s/files/1/0027/8134/7953/files/review-2.svg?8353109349744174613",
    "https://cdn.shopify.com/s/files/1/0027/8134/7953/files/review-3.svg?8353109349744174613",
    "https://cdn.shopify.com/s/files/1/0027/8134/7953/files/review-4.svg?8353109349744174613",
    "https://cdn.shopify.com/s/files/1/0027/8134/7953/files/review-5.svg?3416142710543350677",
  ],
};

var reviews = {
  // State
  page: 1,
  reviews: [],
  loggedIn: false,
  hasPurchased: false,
  reviewScore: null,

  init: function init() {
    if (window.location.pathname.startsWith("/product")) {
      reviews.qualifyUser();
      reviews.getInitialReviews();
      reviews.registerClickEvents();
      reviews.setLoginRedirect();
      reviews.checkRedirectHash();
    }
  },
  registerClickEvents: function registerClickEvents() {
    reviews.onLoadMoreClick();
    reviews.onReviewSummaryClick();
    reviews.onReviewScoreClick();
    reviews.onAuthorClick();
    reviews.onAuthorCancel();
    reviews.onCloseModalClick();
    reviews.onReviewSubmit();
    reviews.onReviewScoreHover();
  },
  hoverConstructor: function hoverConstructor(selector, mouseIn, mouseOut) {
    $(selector).mouseenter(mouseIn).mouseleave(mouseOut);
  },
  onLoadMoreClick: function onLoadMoreClick() {
    $(".product__reviews__root > .load").on("click", function () {
      reviews.getAdditionalReviews();
    });
  },
  onReviewSummaryClick: function onReviewSummaryClick() {
    $(document).on("click", ".review__click__target", function () {
      $("html, body").scrollTo(".product__reviews__root", 1000, {
        offset: -60,
      });
    });
  },
  onAuthorClick: function onAuthorClick() {
    $(".review__open__editor, .reviews__write__first").on("click", function () {
      if (reviews.loggedIn) {
        if (reviews.hasPurchased) {
          $(".product__reviews__root > .body").addClass("editing");
        } else {
          reviews.puchaseGate();
        }
      } else {
        reviews.loginGate();
      }
    });
  },
  onAuthorCancel: function onAuthorCancel() {
    $(".review__close__editor").on("click", function () {
      $(".product__reviews__root > .body").removeClass("editing");
    });
  },
  onReviewSubmit: function onReviewSubmit() {
    $(".product__reviews__editor__form").on("submit", function (e) {
      e.preventDefault();

      // Validation
      var isValid = true;
      if ($("#reviewHeight").valid()) {
        $("#reviewHeight").parent().removeClass("field__invalid");
      } else {
        $("#reviewHeight").parent().addClass("field__invalid");
        isValid = false;
      }
      if ($("#reviewSize").valid()) {
        $("#reviewSize").parent().removeClass("field__invalid");
      } else {
        $("#reviewSize").parent().addClass("field__invalid");
        isValid = false;
      }
      if ($("#reviewTitle").valid()) {
        $("#reviewTitle").parent().removeClass("field__invalid");
      } else {
        $("#reviewTitle").parent().addClass("field__invalid");
        isValid = false;
      }
      if ($("#reviewBody").valid()) {
        $("#reviewBody").parent().removeClass("field__invalid");
      } else {
        $("#reviewBody").parent().addClass("field__invalid");
        isValid = false;
      }
      if (reviews.reviewScore !== null) {
        $(".score__picker").removeClass("field__invalid");
      } else {
        $(".score__picker").addClass("field__invalid");
        isValid = false;
      }

      // Run the post if it's valid

      if (isValid) {
        // API POST
        var data = {
          appkey: "dZpbXqwKzl2vK0zEuMjXURx0QlXd3F2rTZWAfNc3",
          domain: "https://lulalu-dev.myshopify.com",
          sku: $(".product__reviews__root").data("id"),
          product_title: $(".product__title__1").text(),
          product_url: window.location.href,
          display_name: $(".product__reviews__root").data("name"),
          email: $(".product__reviews__root").data("address"),
          review_content: $("#reviewBody").val(),
          review_title: $("#reviewTitle").val(),
          review_score: reviews.reviewScore,
          custom_fields: {
            "--15625": $("#reviewHeight").val(),
            "--15626": $("#reviewSize").val(),
            "--15629": $("#reviewLocation").val(),
          },
        };
        // Start Loading
        $(".product__reviews__editor").addClass("loading");

        $.ajax({
          type: "POST",
          url: yotpoUtil.POST_URL,
          data: data,
          success: function success(response) {
            if (response.code === 200) {
              reviews.postSuccess();
            } else {
              reviews.postFailure();
            }
          },
        });
      }
    });
  },
  postSuccess: function postSuccess() {
    $(".product__reviews__editor")
      .removeClass("loading")
      .addClass("review__submitted");
  },
  postFailure: function postFailure() {
    alert("Sorry, review failed to post.  Please try again later.");
  },
  onReviewScoreHover: function onReviewScoreHover() {
    reviews.hoverConstructor(
      ".review__score__option",
      reviews.onReviewScoreMouseIn,
      reviews.onReviewScoreMouseOut
    );
  },
  onReviewScoreMouseIn: function onReviewScoreMouseIn(e) {
    var score = e.target.dataset.value;
    var ref = $(".review__score__option");
    // Update bubble style
    $(ref).each(function () {
      var val = $(this).data("value");
      if (val <= score) {
        $(this).addClass("hover");
      }
    });
  },
  onReviewScoreMouseOut: function onReviewScoreMouseOut(e) {
    $(".review__score__option").removeClass("hover");
  },
  onReviewScoreClick: function onReviewScoreClick() {
    $(".review__score__option").on("click", function (e) {
      var score = $(this).data("value");
      var ref = $(".review__score__option");
      var html = "<span>" + score + "/5</span>";
      // Append text score
      $(".score__picker > .wrap > .total").html(html);

      // Set score
      reviews.reviewScore = score;

      // Update bubble style
      $(ref).each(function () {
        var val = $(this).data("value");
        if (val <= score) {
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });
    });
  },
  setLoginRedirect: function setLoginRedirect() {
    var value = window.location.pathname + "#write";
    $(".guest__login__target").attr("value", value);
  },
  checkRedirectHash: function checkRedirectHash() {
    var hash = window.location.hash;
    if (hash && hash === "#write") {
      if (reviews.hasPurchased) {
        $(".product__reviews__root > .body").addClass("editing");
        $("html, body").scrollTo(".product__reviews__root", 1000, {
          offset: -60,
        });
      } else {
        reviews.puchaseGate();
      }
    }
  },
  qualifyUser: function qualifyUser() {
    // There's a logged in user
    var loggedIn = $(".product__reviews__root").data("user") === true;
    reviews.loggedIn = loggedIn;
    // They've made this purchase
    if (loggedIn) {
      var id = $(".product__reviews__root").data("id");
      var ref = $(".ordered__item");
      var items = [];
      if (ref.length) {
        $(ref).each(function () {
          var val = $(this).data("id");
          items.push(val);
        });
        if (items.includes(id)) {
          reviews.hasPurchased = true;
        }
      }
    }
  },
  getInitialReviews: function getInitialReviews() {
    var id = $(".product__top__root").data("id");
    var url =
      "https://api.yotpo.com/v1/widget/" +
      yotpoUtil.APP_KEY +
      "/products/" +
      id +
      "/reviews.json?per_page=" +
      (site.isMobile ? 1 : 3) +
      "&page=" +
      reviews.page;
    // Turn on loading state
    reviews.toggleLoading(true);

    // Run query
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status.code === 200) {
          // Update the static data points
          if (data.response.reviews.length) {
            reviews.renderInitialReviews(data.response.reviews);
            reviews.renderReviewDetails(
              data.response.bottomline.average_score,
              data.response.bottomline.total_review
            );
          } else {
            reviews.noReviews();
          }
        } else {
          reviews.apiError();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  getAdditionalReviews: function getAdditionalReviews() {
    var id = $(".product__top__root").data("id");
    var url =
      "https://api.yotpo.com/v1/widget/" +
      yotpoUtil.APP_KEY +
      "/products/" +
      id +
      "/reviews.json?per_page=" +
      (site.isMobile ? 1 : 3) +
      "&page=" +
      reviews.page;
    // Turn on loading state
    reviews.toggleLoading(true);

    // Run query
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status.code === 200) {
          // Update the static data points
          if (data.response.reviews.length) {
            reviews.renderAdditionalReviews(data.response.reviews);
          } else {
            reviews.allReviewsLoaded();
          }
        } else {
          reviews.apiError();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  renderInitialReviews: function renderInitialReviews(reviewObject) {
    if (reviewObject.length) {
      var proxy = $(".review__item__clone").clone();
      // Append clones
      _.map(reviewObject, function (review, index) {
        var clone = proxy.clone();
        clone.removeClass("review__item__clone");
        clone.removeClass("display__none");
        // Get the data
        var title = review.title,
          score = review.score,
          content = review.content,
          user = review.user,
          created_at = review.created_at,
          custom_fields = review.custom_fields;

        var img = yotpoUtil.SCORES[score - 1];
        var date = moment(created_at).format("MM.DD.YY");
        var name = user.display_name;
        // Apply them to clone
        clone.find("img").attr("src", img);
        clone.find(".name").text(name);
        clone.find(".date").text(date);
        clone.find(".review__content > h3").html(title);
        clone.find(".review__content > p").html(content);
        // Append Custom Fields if they exist (these arbitrary --156XX values need to be retreived from a Yotpo support person)
        if (custom_fields !== null) {
          if (custom_fields["--15625"]) {
            var height = custom_fields["--15625"].value;
            clone.find(".height").text("Height: " + height);
          } else {
            clone.find(".height").text("");
          }
          if (custom_fields["--15626"]) {
            var size = custom_fields["--15626"].value;
            clone.find(".size").text("Size: " + size);
          } else {
            clone.find(".size").text("");
          }
        }
        // Append it
        $(".product__review__body__items").append(clone);
      });
      // Nonce Review Index
      reviews.page++;
    } else {
      reviews.allReviewsLoaded();
    }
    // Turn off loading state
    reviews.toggleLoading(false);
  },
  renderAdditionalReviews: function renderAdditionalReviews(reviewObject) {
    var proxy = $(".review__item__clone").clone();
    var scrollTarget = void 0;
    // Append clones
    _.map(reviewObject, function (review, index) {
      var clone = proxy.clone();
      clone.removeClass("review__item__clone");
      clone.removeClass("display__none");
      // Get the data
      var title = review.title,
        score = review.score,
        content = review.content,
        user = review.user,
        created_at = review.created_at,
        custom_fields = review.custom_fields;

      var img = yotpoUtil.SCORES[score - 1];
      var date = moment(created_at).format("MM.DD.YY");
      var name = user.display_name;
      // Apply them to clone
      clone.find("img").attr("src", img);
      clone.find(".name").text(name);
      clone.find(".date").text(date);
      clone.find(".review__content > h3").html(title);
      clone.find(".review__content > p").html(content);
      // Append Custom Fields if they exist (these arbitrary --156XX values need to be retreived from a Yotpo support person)
      if (custom_fields !== null) {
        if (custom_fields["--15625"]) {
          var height = custom_fields["--15625"].value;
          clone.find(".height").text("Height: " + height);
        } else {
          clone.find(".height").text("");
        }
        if (custom_fields["--15626"]) {
          var size = custom_fields["--15626"].value;
          clone.find(".size").text("Size: " + size);
        } else {
          clone.find(".size").text("");
        }
      }
      // Add a helper class for auto scrolling
      var cname = "reviews__page-" + reviews.page;
      scrollTarget = "." + cname;
      if (index === 0) {
        clone.addClass(cname);
      }
      // Append it
      $(".product__review__body__items").append(clone);
    });
    // Turn off loading state
    reviews.toggleLoading(false);
    // Scroll to the result
    $("html, body").scrollTo(scrollTarget, 1000, { offset: -60 });

    // Nonce API Pagination Index
    reviews.page++;
  },
  renderReviewDetails: function renderReviewDetails(score, count) {
    var full = $(".review__clone__full")
      .clone()
      .removeClass("review__clone__full display__none");
    var half = $(".review__clone__half")
      .clone()
      .removeClass("review__clone__half display__none");

    // Append Full
    for (i = 0; i < parseInt(score); i++) {
      var clone = full.clone();
      $(".price__rating > .price > p > span").append(clone);
    }
    // Append Half
    var decimal = score % 1;
    if (decimal >= 0.3) {
      var _clone = half.clone();
      $(".price__rating > .price > p > span").append(_clone);
    }
    // Append Count
    var html =
      '<span class="count review__click__target">(' + count + ")</span>";
    $(".price__rating > .price > p > span").append(html);

    // Review Block
    var roundedScore = Math.round(score * 10) / 10;
    var revScore = roundedScore + "/5";
    var revCount = count + " Reviews";
    $(".product__review__body__heading > .score > h2").text(revScore);
    $(".product__review__body__heading > .count > h2").text(revCount);
  },
  onCloseModalClick: function onCloseModalClick() {
    $(".reviews__close__modal").on("click", function () {
      $(".product__review__modal__root").addClass("display__none");
    });
  },
  loginGate: function loginGate() {
    $(".product__review__modal__root")
      .addClass("login")
      .removeClass("display__none");
  },
  puchaseGate: function puchaseGate() {
    $(".product__review__modal__root")
      .addClass("purchase")
      .removeClass("display__none");
  },
  toggleLoading: function toggleLoading(bool) {
    if (bool) {
      $(".product__reviews__root > .load").addClass("loading");
    } else {
      $(".product__reviews__root > .load").removeClass("loading");
    }
  },
  allReviewsLoaded: function allReviewsLoaded() {
    // Turn off loading state
    reviews.toggleLoading(false);
    $(".product__reviews__root > .load").addClass("all__loaded");
    $(".product__reviews__root > .load > span").text("All Reviews Loaded");
  },
  apiError: function apiError() {
    $(".product__reviews__root > .load").addClass("api__error");
    $(".product__reviews__root > .load > span").text("Couldn't Fetch Reviews");
  },
  noReviews: function noReviews() {
    // Turn off loading state
    reviews.toggleLoading(false);
    var html = '<span class="no__reviews">No Reviews</span>';
    $(".price__rating > .price > p").append(html);
    $(".product__reviews__root > .body").addClass("no__reviews");
    $(".product__reviews__root > .load").remove();
  },
};

("use strict");

var sticky = {
  init: function init() {
    sticky.registerStickyListeners();
  },
  registerStickyListeners: function registerStickyListeners() {
    if (
      (!site.isMobile && window.location.pathname.startsWith("/pages/term")) ||
      (!site.isMobile && window.location.pathname.startsWith("/pages/faq"))
    ) {
      sticky.onTermsScroll();
    }
  },
  onTermsScroll: function onTermsScroll() {
    $(window).scroll(function (event) {
      var scrollPosition = $(window).scrollTop();
      if (scrollPosition > 200) {
        $(".section-navigation").addClass("desktop__tablet__fixed");
      } else {
        $(".section-navigation").removeClass("desktop__tablet__fixed");
      }
    });
  },
};

("use strict");

var polyfill = {
  init: function init() {
    polyfill.checkBrowser();
  },
  getIEVersion: function getIEVersion() {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");

    // If IE, return version number.
    if (Idx > 0)
      return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
    // If IE 11 then look for Updated user agent string.
    else if (!!navigator.userAgent.match(/Trident\/7\./)) return 11;
    else return 0; //It is not IE
  },
  checkBrowser: function checkBrowser() {
    var version = polyfill.getIEVersion();
    if (version > 0) {
      polyfill.insertStylesheet();
    }
  },
  insertStylesheet: function insertStylesheet() {
    var src = $(".polyfill__src").data("src");
    var link = $("<link />", {
      rel: "stylesheet",
      type: "text/css",
      href: src,
    });
    $("head").append(link);
  },
};

("use strict");

var lazy = {
  // For use in other constructors
  controller: null,

  init: function init() {
    lazy.registerLazyImages();
  },
  registerLazyImages: function registerLazyImages() {
    lazy.controller = new LazyLoad({
      elements_selector: ".lazy__load",
    });
  },
};

var style = {
  init: function init() {
    if (window.location.pathname === "/pages/bra-101") {
      style.setUpPage();
      style.initSwiper();
      style.registerClickEvents();
      style.showAnchoredSection();
    }
  },
  showAnchoredSection: function showAnchoredSection() {
    var hash = window.location.hash;
    $(hash).trigger("click").blur();
  },
  // Sets up which section to show on page arrival
  setUpPage: function setUpPage() {
    var styleGuide = $("section").first().addClass("display");
    $(".slider-item").first().addClass("visited-link");
    $("section").not(styleGuide).addClass("hidden");
  },
  initSwiper: function initSwiper() {
    var carouselContainers = document.querySelectorAll(".bra-101-root");

    for (var i = 0; i < carouselContainers.length; i++) {
      var container = carouselContainers[i];
      initCarouselContainer(container);
    }

    function initCarouselContainer(container) {
      var carousel = container.querySelector(".slider__bra-101");
      var flkty = new Flickity(carousel, {
        cellAlign: "center",
        contain: false,
        wrapAround: false,
        pageDots: false,
        prevNextButtons: true,
        setGallerySize: false,
        initialIndex: 0,
        lazyLoad: 2,
      });

      flkty.on("change", function updateStatus() {
        var slideNumber = flkty.selectedIndex + 1;
        var carouselStatus = container.querySelector(".slide__count");
        carouselStatus.textContent = slideNumber;
      });
    }
  },
  registerClickEvents: function registerClickEvents() {
    $(".slider-item").on("click", function (e) {
      e.preventDefault();
      style.scrollOptions();
      $(".slider-item").not(this).removeClass("visited-link");
      var className = this.innerText.toLowerCase().replace(/ /g, "-");
      var displaySection = "." + className;
      $(displaySection).removeClass("hidden");
      $(displaySection).addClass("display");
      $(this).addClass("visited-link");
      $(".link-bar").not(this).removeClass("visited-link");
      $("section").not(displaySection).addClass("hidden");
      $("section").not(displaySection).removeClass("display");
    });
  },
  scrollOptions: function scrollOptions() {
    var targetOffset = $(".slider").offset().top - 50;
    $("html, body").animate({ scrollTop: targetOffset }, 800);
  },
};

var blog = {
  postPerPage: 3,
  endPoint: 0,
  blogCounter: 0,
  blogPostList: $("#blog-post-list"),
  loadMorePostsButton: $("#load-more-posts"),
  tagFilterSelector: $("#tag-filter a"),
  selectedTagFilter: "",
  init: function init() {
    blog.showMorePosts();
    blog.loadMorePostsClickEventInit();
    blog.filterPostsByTag();
  },
  filterPostsByTag: function filterPostsByTag() {
    $(blog.tagFilterSelector).on("click", function () {
      $(blog.tagFilterSelector).removeClass("on");
      $(this).addClass("on");
      blog.selectedTagFilter = $(this).data("tag");

      blog.endPoint = 0;
      blog.showMorePosts();

      $("html, body").animate(
        {
          scrollTop: $(blog.blogPostList).offset().top - 100,
        },
        500
      );
      return false;
    });
  },
  loadMorePostsClickEventInit: function loadMorePostsClickEventInit() {
    $(blog.loadMorePostsButton).on("click", function () {
      blog.showMorePosts();
      return false;
    });
  },
  showMorePosts: function showMorePosts() {
    blog.hideAllPosts();
    blog.recalculateEndPoint();

    if (blog.selectedTagFilter != "") {
      blog.recalculatePostLength(blog.selectedTagFilter);
      blog.showPostsBySelector(blog.selectedTagFilter);
    } else {
      blog.recalculatePostLength("product__root");
      blog.showPostsBySelector("product__root");
      // $(blog.blogPostList).find(".product__root").slice(0, blog.endPoint).show();
    }

    blog.togleLoadMoreButton();
  },
  hideAllPosts: function hideAllPosts() {
    $(blog.blogPostList).find(".product__root").hide();
  },
  showPostsBySelector: function showPostsBySelector(selector) {
    $(blog.blogPostList)
      .find("." + selector)
      .slice(0, blog.endPoint)
      .show();
  },
  recalculateEndPoint: function recalculateEndPoint() {
    blog.endPoint = blog.endPoint + blog.postPerPage;
  },
  recalculatePostLength: function recalculatePostLength(selector) {
    blog.blogCounter = $(blog.blogPostList).find("." + selector).length;
  },
  togleLoadMoreButton: function togleLoadMoreButton() {
    if (blog.endPoint >= blog.blogCounter) {
      $(blog.loadMorePostsButton).hide();
    } else {
      $(blog.loadMorePostsButton).show();
    }
  },
};

$(document).ready(function () {
  var tryInit = function tryInit() {
    if (site) {
      site.init();
    } else {
      setTimeout(tryInit, 200);
    }
  };

  tryInit();
}); //****************************//
//    Start LuLa Lu Script    //
//****************************//

var site = {
  // State
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  cloud: {
    contact:
      "https://us-central1-dazzling-being-221123.cloudfunctions.net/contact-form-2",
  },
  init: function init() {
    site.setGlobalListeners();
    site.setGlobalClickEvents();
    // site.checkForPromoCookie();
    site.checkIfLookingForCartUrl();
    site.checkIfLookingForRegisterUrl();
    site.checkIfLookingForLoginUrl();
    site.checkIfResetRequestSuccessful();
    site.onContactFormSubmit();
    // site.onPromoExit();
    var sections = [
      "lazy",
      "polyfill",
      "home",
      "collection",
      "product",
      "header",
      "drawer",
      "fit",
      "cart",
      "validation",
      "account",
      "klaviyo",
      "scroller",
      "accordion",
      "returns",
      "reviews",
      "sticky",
      "style",
      "blog",
      "insta",
    ];

    _.each(sections, function (section) {
      window[section].init();
    });

    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (iOS) {
      $("html").addClass("ios");
    }
  },
  setGlobalListeners: function setGlobalListeners() {
    site.screenSizeListener();
  },
  setGlobalClickEvents: function setGlobalClickEvents() {
    site.onCloseModal();
  },
  screenSizeListener: function screenSizeListener() {
    var $window = $(window);

    function checkWidth() {
      var windowsize = $window.width();

      if (windowsize < 600) {
        site.isMobile = true;
        site.isTablet = false;
        site.isDesktop = false;
      } else if (windowsize > 600 && windowsize <= 900) {
        site.isMobile = false;
        site.isTablet = true;
        site.isDesktop = false;
      } else {
        site.isMobile = false;
        site.isTablet = false;
        site.isDesktop = true;
      }
    }

    checkWidth();
    $(window).resize(checkWidth);
  },
  setCookie: function setCookie(cname, cvalue, exdays, single) {
    var expires = void 0;

    if (single) {
      expires = 0;
    } else {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      expires = "expires=" + d.toUTCString();
    }

    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },
  getCookie: function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }

      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  },
  checkIfLookingForCartUrl: function checkIfLookingForCartUrl() {
    if (window.location.pathname.startsWith("/cart")) {
      drawer.showCart();
      drawer.open();
    }
  },
  checkIfLookingForLoginUrl: function checkIfLookingForLoginUrl() {
    if (window.location.pathname === "/account/login") {
      var hash = location.hash;

      if (hash === "#recover") {
        drawer.showReset();
      } else if (hash === "#reset-success") {
        drawer.showSuccess();
      } else {
        drawer.showSignIn();
      }

      drawer.open();
    }
  },
  checkIfResetRequestSuccessful: function checkIfResetRequestSuccessful() {
    if (window.location.pathname.startsWith("/account/reset/")) {
      drawer.showResetForm();
      drawer.open();
    }
  },
  checkIfLookingForRegisterUrl: function checkIfLookingForRegisterUrl() {
    if (window.location.pathname === "/account/register") {
      drawer.showRegister();
      drawer.open();
    }
  },
  onCloseModal: function onCloseModal() {
    $(".modal__close").on("click", function () {
      $(".modal__root").addClass("display__none");
      site.unlockBodyScroll();
    });
  },
  onContactFormSubmit: function onContactFormSubmit() {
    $(".form__contact").on("submit", function (e) {
      e.preventDefault();
      var data = {};
      data.first = $("#contactFirst").val();
      data.last = $("#contactLast").val();
      data.email = $("#contactEmail").val();
      data.phone = $("#contactPhone").val();
      data.subject = $("#contactSubject").val();
      data.comments = $("#contactComments").val();
      $(this).addClass("loading");
      console.log(data);
      $.ajax({
        type: "POST",
        url: site.cloud.contact,
        data: {
          data: data,
        },
        success: function success(response) {
          console.log("Sent:", response);
          site.contactSuccess();
        },
      });
    });
  },
  getUrlParams: function getUrlParams(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
      ? null
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  },
  // checkForPromoCookie: function checkForPromoCookie() {
  //   var hasDismissedPromo = site.getCookie("hasDismissedPromo");

  //   if (hasDismissedPromo !== "true") {
  //     $(".promo__bar__root").removeClass("display__none");
  //   }
  // },
  // onPromoExit: function onPromoExit() {
  //   $(".promo__close").on("click", function() {
  //     $(".promo__bar__root")
  //       .css("opacity", 0)
  //       .css("bottom", "-100px"); // Set single session cookie

  //     site.setCookie("hasDismissedPromo", true, null, true);
  //   });
  // },
  contactSuccess: function contactSuccess() {
    $(".section-top").html("<h3>Thanks, your email was submitted!</h3>");
  },
  lockBodyScroll: function lockBodyScroll() {
    $("body").addClass("scroll__lock");
  },
  unlockBodyScroll: function unlockBodyScroll() {
    $("body").removeClass("scroll__lock");
  },
  toTop: function toTop() {
    $("html, body").scrollTo("#MainContent", 500);
  },
  mobileScrollHandler: function mobileScrollHandler(event) {
    event.preventDefault();
  },
  lockTouchMove: function lockTouchMove() {
    document.addEventListener("touchmove", site.mobileScrollHandler, {
      passive: false,
    });
  },
  unLockTouchMove: function unLockTouchMove() {
    document.removeEventListener("touchmove", site.mobileScrollHandler, false);
  },
};

function clAddMainProduct() {
  // $('.product__add__btn').click();
  var tid = product.activeVariant,
    qty = 1,
    title = $(".product__title__1").text();
  product.startLoadingState();
  cart.startLoadingState();
  cart.setAnimationText(title, $(".product__top__root").data("id"));
  cart.addItem(tid, qty, true);
  console.log("here " + id);
}
$(document).on("click", ".cl_cart_btn", function () {
  // clAddMainProduct();
  var tid = product.activeVariant;
  var id = $(this).attr("data-id");

  var qty = 1;
  var title = $(this).attr("data-title");
  product.startLoadingState();
  cart.startLoadingState();
  //cart.setAnimationText(title," ");
  cart.addItem(id, qty, true);
});
$(document).on("click", ".clOptionsColor", function () {
  var cl_color = $(this).attr("data-ocolor");
  var pid = $(this).attr("data-handle");
  var cl_size = $(".Size_" + pid + ".cl_size_selected").attr("data-size");

  $(".Color_" + pid).removeClass("cl__color_selected");
  $(this).addClass("cl__color_selected");
  var clActivColor = document
    .querySelector(".Color_" + pid + ".cl__color_selected")
    .getAttribute("data-color");

  $(".clColorName_" + pid).text(clActivColor);
  var clActivImage = document.querySelectorAll(".clPimage_" + pid);
  for (var t = 0; t < clActivImage.length; t++) {
    if (
      clActivImage[t].getAttribute("data-color") == clActivColor.toLowerCase()
    ) {
      clActivImage[t].classList.remove("hide");
    } else {
      clActivImage[t].classList.add("hide");
    }
  }

  jQuery.getJSON(
    window.Shopify.routes.root + "products/" + pid + ".js",
    function (product) {
      for (var p = 0; p < product.variants.length; p++) {
        if (
          product.variants[p].title.includes(cl_color) &&
          product.variants[p].title.includes(cl_size)
        ) {
          if (product.variants[p].available == true) {
            $(".cl_add_" + product.id).attr("data-id", product.variants[p].id);
            $(".cl_add_" + product.id).removeClass("disabled");
            $(".cl_add_" + product.id).text(
              "ADD +$" + product.variants[p].price / 100 + ".00"
            );
          } else {
            $(".cl_add_" + product.id).addClass("disabled");
            $(".cl_add_" + product.id).text("Out of Stock");
          }
        }
      }
    }
  );
});

$(document).on("click", ".clOptionsSize", function () {
  var cl_size = $(this).attr("data-size");
  var pid = $(this).attr("data-handle");
  var cl_color = $(".Color_" + pid + ".cl__color_selected").attr("data-ocolor");
  $(".Size_" + pid).removeClass("cl_size_selected");
  $(this).addClass("cl_size_selected");

  jQuery.getJSON(
    window.Shopify.routes.root + "products/" + pid + ".js",
    function (product) {
      for (var p = 0; p < product.variants.length; p++) {
        if (
          product.variants[p].title.includes(cl_color) &&
          product.variants[p].title.includes(cl_size)
        ) {
          if (product.variants[p].available == true) {
            $(".cl_add_" + product.id).attr("data-id", product.variants[p].id);
            $(".cl_add_" + product.id).removeClass("disabled");
            $(".cl_add_" + product.id).text(
              "ADD +$" + product.variants[p].price / 100 + ".00"
            );
          } else {
            $(".cl_add_" + product.id).addClass("disabled");
            $(".cl_add_" + product.id).text("Out of Stock");
          }
        }
      }
    }
  );
});
$(document).on("click", ".und_Size", function () {
  var cl_size = $(this).attr("data-size");
  var pid = $(this).attr("data-handle");
  var cl_color = $(".Color_" + pid + ".cl__color_selected").attr("data-ocolor");
  var cup_size = $(".Size_" + pid + ".cl_size_selected" + ".und_Cup").attr(
    "data-size"
  );
  $(".UndSize_" + pid + ".und_Size").removeClass("cl_size_selected");
  $(this).addClass("cl_size_selected");

  jQuery.getJSON(
    window.Shopify.routes.root + "products/" + pid + ".js",
    function (product) {
      for (var p = 0; p < product.variants.length; p++) {
        if (
          product.variants[p].title.includes(cl_color) &&
          product.variants[p].title.includes(cl_size) &&
          product.variants[p].options.indexOf(cup_size) > 0
        ) {
          if (product.variants[p].available == true) {
            console.log(product.variants[p].title);
            $(".cl_add_" + product.id).attr("data-id", product.variants[p].id);
            $(".cl_add_" + product.id).removeClass("disabled");
            $(".cl_add_" + product.id).text(
              "ADD +$" + product.variants[p].price / 100 + ".00"
            );
          } else {
            $(".cl_add_" + product.id).addClass("disabled");
            $(".cl_add_" + product.id).text("Out of Stock");
          }
        }
      }
    }
  );
});
$(document).on("click", ".und_Cup", function () {
  var cup_size = $(this).attr("data-size");
  var pid = $(this).attr("data-handle");
  var cl_color = $(".Color_" + pid + ".cl__color_selected").attr("data-ocolor");
  var cl_size = $(".Size_" + pid + ".cl_size_selected" + ".und_Size").attr(
    "data-size"
  );
  $(".UndSize_" + pid + ".und_Cup").removeClass("cl_size_selected");
  $(this).addClass("cl_size_selected");

  jQuery.getJSON(
    window.Shopify.routes.root + "products/" + pid + ".js",
    function (product) {
      for (var p = 0; p < product.variants.length; p++) {
        if (
          product.variants[p].title.includes(cl_color) &&
          product.variants[p].title.includes(cl_size) &&
          product.variants[p].options.indexOf(cup_size) > 0
        ) {
          if (product.variants[p].available == true) {
            $(".cl_add_" + product.id).attr("data-id", product.variants[p].id);
            $(".cl_add_" + product.id).removeClass("disabled");
            $(".cl_add_" + product.id).text(
              "ADD +$" + product.variants[p].price / 100 + ".00"
            );
          } else {
            $(".cl_add_" + product.id).addClass("disabled");
            $(".cl_add_" + product.id).text("Out of Stock");
          }
        }
      }
    }
  );
});
$(document).on("click", ".MainProdC", function () {
  var actCl = $(this).attr("data-color");
  var actClTemp = $(this).attr("data-color");
  console.log('tessst' + $(".MainColorswitch").length)
  if ($(".MainColorswitch").length > 2) {
    if (actCl != "beige" && actCl != "black" && actCl != "ruby") {
      var actCl = "beige";
      var changeName = document.querySelectorAll(".clLinkMain");
      for (var i = 0; i < changeName.length; i++) {
        changeName[i].innerText = "Beige";
      }
    } else {
      var actCl = actClTemp;
    }
  }

  var MatchinProductsColor = document.querySelectorAll(".clOptionsColor");
  var MatchinProductsImage = document.querySelectorAll(".clImages");

  for (var t = 0; t < MatchinProductsColor.length; t++) {
    if (
      MatchinProductsColor[t].getAttribute("data-color").toLowerCase() == actCl
    ) {
      MatchinProductsColor[t].classList.add("cl__color_selected");
    } else {
      MatchinProductsColor[t].classList.remove("cl__color_selected");
    }
  }
  for (var t = 0; t < MatchinProductsImage.length; t++) {
    if (
      MatchinProductsImage[t].getAttribute("data-color").toLowerCase() == actCl
    ) {
      MatchinProductsImage[t].classList.remove("hide");
    } else {
      MatchinProductsImage[t].classList.add("hide");
    }
  }
  var er = document.querySelectorAll(".cl__color_selected.clOptionsColor");
  for (var y = 0; y < er.length; y++) {
    var pid = er[y].attributes[1].value;
    jQuery.getJSON(
      window.Shopify.routes.root + "products/" + pid + ".js",
      function (product) {
        for (var p = 0; p < product.variants.length; p++) {
          var cl_size = $(".Size_" + pid + ".cl_size_selected").attr(
            "data-size"
          );
          var cl_color = $(".Color_" + pid + ".cl__color_selected").attr(
            "data-ocolor"
          );
          if (
            product.variants[p].title.includes(cl_color) &&
            product.variants[p].title.includes(cl_size)
          ) {
            if (product.variants[p].available == true) {
              $(".cl_add_" + product.id).attr(
                "data-id",
                product.variants[p].id
              );
              $(".cl_add_" + product.id).removeClass("disabled");
              $(".cl_add_" + product.id).text(
                "ADD +$" + product.variants[p].price / 100 + ".00"
              );
            } else {
              $(".cl_add_" + product.id).addClass("disabled");
              $(".cl_add_" + product.id).text("Out of Stock");
            }
          }
        }
      }
    );
  }
});


  